import { jsx as e, jsxs as d, Fragment as R } from "react/jsx-runtime";
import { withManagedProps as b } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as g } from "@made-people/react-prop-guard";
import pe, { useEffect as L, useState as x, isValidElement as Ct, useRef as ye, useCallback as we, useMemo as At } from "react";
import { p as Dt, a as It, b as j, c as zt, s as Lt, d as xt, e as Gt, f as Wt, g as Ot, h as Rt, i as jt, j as Kt, k as Mt, l as Et, m as Ht, n as Vt, o as $t, q as Ut, r as Ft, t as Qt, u as qt, v as me, w as Zt, x as Yt, y as Jt, z as Xt, A as ea, B as ta, C as aa, D as ia, E as na, F as oa, G as sa, H as ra, I as la, J as ne } from "./blueprint-572e03d6.mjs";
import { Drawer as A } from "@made-people/blueprint-drawer";
import * as Z from "@radix-ui/react-dialog";
import { useOverlayState as ca, overlayEventEmitter as Y } from "@made-people/blueprint-overlay";
import { useProductBase as C, ProductLink as re, useProductAttributeGetter as H, useProductPriceInfo as le, useProductDataModel as O, useBundlePurchaseInfo as he, useProductImages as da, useMediaAttributeGetter as _e, useRelatedProducts as be, ProductProvider as Ne, filterMediaOnAttributeValues as Ge, useProductSpecificationGroup as ua, useProductAttribute as z, useProductPurchaseStatus as ge, useProductOptions as Te, useProductSiblings as We, useBundleOptions as Be, useBundleItemId as pa, useBundlePurchaseStatus as ma, useProductHasOptionsInStock as ha } from "@made-people/grease-product";
import { useTranslate as k } from "@made-people/grease-translations";
import ba from "clsx";
import { accordionItemSchema as ga, accordionSchema as fa, Accordion as Pa } from "@made-people/blueprint-accordion";
import { useKeenSlider as xe } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ResponsiveImage as V, responsiveImageSchema as Oe } from "@made-people/blueprint-responsive-image";
import { useBreakpointVisibility as va } from "@made-people/blueprint-ui-hooks";
import { responsiveVideoSchema as Sa, ResponsiveVideo as Re } from "@made-people/blueprint-responsive-video";
import { MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY as je } from "@made-people/blueprint-mix-and-match";
import { badgeSchema as Ke, Badge as Ce } from "@made-people/blueprint-badge";
import { CartEventAdditionalDataProvider as ya, useUpdateCart as fe, useCartMethod as wa } from "@made-people/grease-cart";
import { uiEventEmitter as ka } from "@made-people/grease-ui-events";
import { Heading as _a } from "@made-people/blueprint-heading";
import { isNotUndefined as Na } from "@made-people/typeguards-common";
import { motion as E, AnimatePresence as J, cubicBezier as Me } from "motion/react";
import { linkAsLinkSchema as Ta, Link as Ba, LinkAsLink as Ca, linkAsButtonSchema as Aa, LinkAsButton as Da } from "@made-people/blueprint-link";
import { buttonContentPropsSchema as X, ButtonAsButton as oe, Button as $, buttonAsButtonSchema as ke, ButtonAsSpan as Ee, buttonAsSpanSchema as Ia } from "@made-people/blueprint-button";
import { toast as za } from "sonner";
import { productCardSchema as La, ProductCard as xa } from "@made-people/blueprint-product-card";
import { SearchResultProvider as He, useSearchResultItems as Ga } from "@made-people/grease-search";
import { swipeableProductListSchema as Ve, SwipeableProductList as Wa } from "@made-people/blueprint-swipeable-product-list";
import { Markdown as Oa } from "@made-people/blueprint-markdown";
import { GridContext as Ra } from "@made-people/blueprint-grid";
import { Breadcrumbs as U, breadcrumbsSchema as ja } from "@made-people/blueprint-breadcrumbs";
import { shippingBarometerSchema as Ka, ShippingBarometer as Ma } from "@made-people/blueprint-shipping-barometer";
import { NotifyMe as $e } from "@made-people/blueprint-notify-me";
import { StatusInformationIcon as Ea } from "@made-people/blueprint-icons";
import { useLink as Ha } from "@made-people/grease-link";
import "@made-people/blueprint";
const Va = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12.9 12.9",
    children: /* @__PURE__ */ e("path", { d: "M7.5,6.5L12.7,1.3c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-5.2,5.2L1.3.2C1,0,.5,0,.2.2s-.2.3-.2.5,0,.4.2.5l5.2,5.2L.2,11.6c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l5.2-5.2,5.2,5.2c.1.1.3.2.5.2s.4,0,.5-.2.2-.3.2-.5,0-.4-.2-.5l-5.2-5.2Z" })
  }
), $a = ({
  children: a,
  CloseIcon: i,
  slots: n
}) => {
  const { isOpen: o, onChange: s } = ca();
  return L(() => {
    s(!0);
  }, []), /* @__PURE__ */ e(Z.Root, { defaultOpen: !0, onOpenChange: s, open: o, children: /* @__PURE__ */ d(Z.Portal, { children: [
    /* @__PURE__ */ e(Z.Overlay, { className: n.modalOverlay }),
    /* @__PURE__ */ d(
      Z.Content,
      {
        "aria-description": "Product Page Modal",
        "aria-describedby": "Product",
        className: n.modalContent,
        children: [
          /* @__PURE__ */ e(Z.Title, { hidden: !0, children: "Product Page" }),
          /* @__PURE__ */ e(Z.Close, { className: n.closeButton, children: i }),
          /* @__PURE__ */ e("section", { className: n.contentWrapper, children: a })
        ]
      }
    )
  ] }) });
}, Ue = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional()
}), Ua = b(
  "ProductDrawer",
  g(
    Ue,
    ({ variants: a, children: i, closeIcon: n = Va, drawerSettings: o }) => {
      const s = Dt.styles(a), [l, r] = x(!1);
      L(() => {
        r(window.innerWidth > 1124);
      }, []);
      const c = () => typeof n == "string" || Ct(n) ? n : typeof n == "function" ? /* @__PURE__ */ e(n, {}) : null;
      return l ? /* @__PURE__ */ e($a, { CloseIcon: c(), slots: s, children: i }) : /* @__PURE__ */ e(
        A,
        {
          ...o,
          defaultOpen: !0,
          direction: "bottom",
          variants: {
            dimmed: "subtle",
            blurred: "subtle",
            background: "none",
            ...o == null ? void 0 : o.variants
          },
          children: /* @__PURE__ */ d(
            A.Content,
            {
              contentSettings: {
                "aria-description": "Content for product popup",
                "aria-describedby": "Product"
              },
              children: [
                /* @__PURE__ */ e(A.Close, { className: s.closeButton, children: c() }),
                /* @__PURE__ */ e(A.Title, { hidden: !0, children: "Product Page popup" }),
                /* @__PURE__ */ e("div", { className: s.drawerWrapper, children: /* @__PURE__ */ e("section", { className: s.contentWrapper, children: i }) })
              ]
            }
          )
        }
      );
    }
  )
), Fe = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional()
}), Fa = b(
  "ProductGrid",
  g(Fe, ({ variants: a, children: i }) => {
    const n = It.styles(a);
    return /* @__PURE__ */ e("section", { className: n.base, children: i });
  })
), Qa = t.discriminatedUnion("template", [
  Ue,
  Fe
]), qa = b(
  "ProductRoot",
  g(Qa, (a) => a.template === "drawer" ? /* @__PURE__ */ e(Ua, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Fa, { ...a }) : null)
), Qe = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  blueprint: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  asLink: t.boolean().optional()
}), Za = b(
  "ProductDetailsName",
  g(
    {
      schema: Qe,
      defaultProps: {
        headingTag: "h1"
      }
    },
    ({ variants: a, text: i, headingTag: n, asLink: o, ...s }) => {
      const l = C(), {
        content: { name: r }
      } = l, u = (s.blueprint ?? j.main).styles(a), m = n ?? "h1", f = i ?? r;
      return o ? /* @__PURE__ */ e(m, { className: u.name, children: /* @__PURE__ */ e(re, { productBase: l, context: "product-card", children: f }) }) : /* @__PURE__ */ e(m, { className: u.name, children: f });
    }
  )
), Ya = t.object({
  variants: t.custom().optional()
}), Ja = b(
  "ProductDetailsShortDescription",
  g(Ya, ({ variants: a }) => {
    const {
      content: { shortDescription: i }
    } = C(), n = j.main.styles(a);
    return i ? /* @__PURE__ */ e("p", { className: n.shortDescription, children: i }) : null;
  })
), Ae = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  readMoreSettings: t.object({
    enabled: t.boolean(),
    limit: t.number().optional()
  }).optional(),
  label: t.string().optional(),
  blueprint: t.custom().optional(),
  formatDotsToList: t.boolean().optional()
}), Xa = b(
  "ProductDetailsDescription",
  g(
    Ae,
    ({
      variants: a,
      readMoreSettings: i,
      text: n,
      label: o,
      formatDotsToList: s,
      ...l
    }) => {
      const {
        content: { description: r }
      } = C(), u = (l.blueprint ?? j.main).styles(a), [m, f] = x(!(i != null && i.enabled)), h = k();
      if (!r && !n)
        return null;
      const P = n ?? r, v = P.length > ((i == null ? void 0 : i.limit) ?? 200), y = s ? P.split(`
`).map((S) => {
        const w = S.trim();
        return w.startsWith("•") ? `<li>${w.substring(1).trim()}</li>` : w ? `${w}` : "";
      }).join("") : P;
      return /* @__PURE__ */ d("div", { className: u.description, children: [
        o && /* @__PURE__ */ e("h2", { className: u.descriptionLabel, children: o }),
        /* @__PURE__ */ e(
          "p",
          {
            className: m ? "" : "line-clamp-2",
            dangerouslySetInnerHTML: {
              __html: m ? y : `${y.substring(0, 200)}...`
            }
          }
        ),
        (i == null ? void 0 : i.enabled) && v && /* @__PURE__ */ e(
          "button",
          {
            className: u.descriptionReadMoreButton,
            onClick: () => f(!m),
            children: h(m ? "Product_Description_Read_Less" : "Product_Description_Read_More")
          }
        )
      ] });
    }
  )
), ei = t.object({
  variants: t.custom().optional()
}), ti = b(
  "ProductDetailsBrand",
  g(ei, ({ variants: a }) => {
    var l;
    const i = C(), n = j.main.styles(a), s = (l = H(i)("brandName", t.string())) == null ? void 0 : l.value;
    return s ? /* @__PURE__ */ e("span", { className: n.brand, children: s }) : null;
  })
), qe = t.object({
  drawerSettings: t.custom().optional(),
  trigger: t.custom().optional(),
  isEnabled: t.boolean().optional()
}), ai = 1024, ii = b(
  "PriceHistoryDrawer",
  g(qe, (a) => {
    var m, f;
    const i = zt.styles(), n = le(), [o, s] = x(!1), l = k(), r = (m = n.previouslyDiscountedPrices) == null ? void 0 : m.find(
      (h) => h.periodDays === 30
    ), c = n.price.formatted !== (r == null ? void 0 : r.price.formatted);
    if (L(() => {
      const h = () => {
        s(window.innerWidth > ai);
      };
      return window.addEventListener("resize", h), h(), () => {
        window.removeEventListener("resize", h);
      };
    }, []), !a.isEnabled)
      return null;
    const u = (f = n.discountInfo) != null && f.percent ? `(-${n.discountInfo.percent}%)` : "";
    return /* @__PURE__ */ d(
      A,
      {
        customOverlayId: "price-history",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        header: {
          headingSettings: {
            heading: l("Price_History_Heading")
          }
        },
        hasHandle: !o,
        variants: {
          dragHandle: o ? "false" : "true",
          rounded: o ? "none" : "strong",
          background: "white",
          direction: o ? "right" : "bottom"
        },
        direction: o ? "right" : "bottom",
        ...a.drawerSettings,
        children: [
          c && /* @__PURE__ */ d(A.Trigger, { className: i.trigger, children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "absolute w-10 h-10",
                tabIndex: -1,
                "aria-hidden": "true"
              }
            ),
            a.trigger
          ] }),
          /* @__PURE__ */ e(A.Content, { children: /* @__PURE__ */ d("div", { className: i.contentWrapper, children: [
            /* @__PURE__ */ d("div", { className: i.priceRow, children: [
              /* @__PURE__ */ e("span", { className: i.priceValue, children: n.price.formatted }),
              u && /* @__PURE__ */ e("span", { className: i.discountBadge, children: l("Price_History_Current_Price", {
                discountPercent: u
              }) })
            ] }),
            r && /* @__PURE__ */ d("div", { className: i.priceRow, children: [
              /* @__PURE__ */ e("span", { className: i.priceValue, children: r.price.formatted }),
              /* @__PURE__ */ e("span", { className: i.priceLabel, children: l("Price_History_Lowest_Price_In_Last_30_Days") })
            ] }),
            /* @__PURE__ */ d("div", { className: i.priceRow, children: [
              /* @__PURE__ */ e("span", { className: i.priceValue, children: n.priceWithoutDiscount.formatted }),
              /* @__PURE__ */ e("span", { className: i.priceLabel, children: l("Price_History_Original_Price") })
            ] })
          ] }) })
        ]
      }
    );
  })
), Ze = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  priceHistoryDrawerSettings: qe.optional()
}), ni = b(
  "ProductDetailsPrice",
  g(Ze, ({ variants: a, ...i }) => {
    const n = le(), s = (i.blueprint ?? j.main).styles(a), l = O(), r = n.price.number < n.priceWithoutDiscount.number;
    return /* @__PURE__ */ e(R, { children: /* @__PURE__ */ d("div", { className: s.priceWrapper, children: [
      /* @__PURE__ */ e(
        "span",
        {
          "data-is-discounted": r ? "true" : "false",
          className: s.price,
          children: n.price.formatted
        }
      ),
      r && /* @__PURE__ */ d("span", { className: s.oldPrice, children: [
        n.priceWithoutDiscount.formatted,
        /* @__PURE__ */ e(
          p.PriceHistoryDrawer,
          {
            ...i.priceHistoryDrawerSettings
          }
        )
      ] }),
      l === "bundle" && /* @__PURE__ */ e(oi, {})
    ] }) });
  })
), oi = () => (he(), null), si = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional()
}), ri = b(
  "ProductDetailsWrapper",
  g(si, ({ variants: a, children: i }) => {
    const n = j.main.styles(a);
    return /* @__PURE__ */ e("section", { className: n.wrapper, children: i });
  })
), ee = t.object({
  variants: t.custom().optional(),
  attributeKey: t.string().optional(),
  className: t.string().optional(),
  label: t.string().optional()
}), li = b(
  "ProductDetailsProductType",
  g(
    {
      schema: ee,
      defaultProps: {
        attributeKey: "subHeadline"
      }
    },
    ({ variants: a, attributeKey: i, className: n, label: o }) => {
      var u;
      const s = C(), r = (u = H(s)(
        i ?? "",
        t.string()
      )) == null ? void 0 : u.value, c = j.main.styles(a);
      if (!(!r && !o))
        return /* @__PURE__ */ e("span", { className: ba(c.productType, n), children: o ?? r });
    }
  )
), Ye = ga.extend({
  content: t.object({
    value: t.string().optional(),
    attributeKey: t.string().optional(),
    trigger: t.custom().optional(),
    content: t.custom().optional(),
    forceMount: t.boolean().optional()
  })
}), ci = t.object({
  variants: t.custom().optional(),
  items: t.array(Ye).optional(),
  settings: fa.omit({ items: !0 }).optional()
}), di = b(
  "ProductDetailsAccordion",
  g(ci, ({ variants: a, items: i, settings: n }) => {
    const o = C(), s = H(o), l = j.main.styles(a), r = i == null ? void 0 : i.map((c) => {
      var m;
      let u = c.content.content;
      if (c.content.attributeKey) {
        const f = (m = s(
          c.content.attributeKey,
          t.string()
        )) == null ? void 0 : m.value;
        if (!u && !f)
          return null;
        u = f ?? u;
      }
      return u ? {
        ...c,
        content: {
          content: u,
          value: c.content.value,
          trigger: c.content.trigger,
          forceMount: c.content.forceMount
        }
      } : null;
    }).filter((c) => c !== null);
    return r ? /* @__PURE__ */ e("div", { className: l.accordionWrapper, children: /* @__PURE__ */ e(
      Pa,
      {
        ...n,
        blueprint: j.accordion,
        layout: {
          spacing: {
            applySpacing: "false"
          },
          position: {
            applyPosition: "false"
          }
        },
        items: r
      }
    ) }) : null;
  })
), ui = {
  Name: Za,
  ShortDescription: Ja,
  Brand: ti,
  Price: ni,
  Wrapper: ri,
  Description: Xa,
  ProductType: li,
  Accordion: di
  // Add other components as needed
}, pi = t.object({
  className: t.string().optional(),
  badgeSettings: Ke.optional(),
  hide: t.boolean().optional()
}), mi = ({
  badgeSettings: a,
  hide: i,
  className: n
}) => {
  const o = k(), s = he(), l = s.discountFromPriceOfItemsOutsideBundle.formatted, r = s.discountFromPriceOfItemsOutsideBundle.number;
  return i || !l || r <= 0 ? null : /* @__PURE__ */ e("div", { className: n, children: /* @__PURE__ */ e(
    Ce,
    {
      ...a,
      label: o("PDP_Bundle_Savings_Badge", { bundleSavings: l })
    }
  ) });
}, Je = b(
  "BundleSavingsBadge",
  g(pi, (a) => O() !== "bundle" ? null : /* @__PURE__ */ e(mi, { ...a }))
), hi = t.object({
  subHeadlineAttribute: t.string().optional(),
  variants: t.custom().optional()
}), bi = b(
  "ShopTheLookItem",
  g(
    {
      schema: hi,
      defaultProps: {
        subHeadlineAttribute: "subHeadline"
      }
    },
    ({ subHeadlineAttribute: a, variants: i }) => {
      var h;
      const n = C(), o = da(), s = le(), l = O(), r = H(n), c = Lt.styles(i), u = o == null ? void 0 : o[0], m = s.price.number < s.priceWithoutDiscount.number, f = a ? (h = r(a, t.string())) == null ? void 0 : h.value : void 0;
      return /* @__PURE__ */ d("div", { className: c.wrapper, children: [
        /* @__PURE__ */ d("div", { className: c.contentWrapper, children: [
          u && /* @__PURE__ */ e(
            re,
            {
              productBase: n,
              context: "product-card",
              className: c.imageWrapper,
              children: /* @__PURE__ */ e(V, { className: c.image, image: u })
            }
          ),
          /* @__PURE__ */ d("div", { className: c.info, children: [
            /* @__PURE__ */ e("h4", { className: c.productName, children: n.content.name }),
            f && /* @__PURE__ */ e("p", { className: c.productType, children: f }),
            /* @__PURE__ */ d("div", { className: c.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": m ? "true" : "false",
                  className: c.price,
                  children: s.price.formatted
                }
              ),
              m && /* @__PURE__ */ e("span", { className: c.priceBeforeDiscount, children: s.priceWithoutDiscount.formatted })
            ] })
          ] })
        ] }),
        l === "with_variants" && /* @__PURE__ */ e(p.SizePicker, { template: "button-grid" }),
        /* @__PURE__ */ e(
          p.AddToCart,
          {
            template: "button",
            postAddAction: "none",
            buttonSettings: {
              variants: {
                width: "full"
              }
            }
          }
        )
      ] });
    }
  )
), De = "shop_the_look", gi = t.object({
  media: t.custom().optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.custom().optional(),
  triggerIcon: t.custom().optional(),
  showProductCountAsSuffix: t.boolean().optional()
}), fi = () => {
  const [a, i] = x(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return L(() => {
    const n = () => {
      i(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, Xe = b(
  "ShopTheLook",
  g(
    {
      schema: gi,
      defaultProps: {}
    },
    ({
      media: a,
      className: i = "",
      variants: n,
      drawerSettings: o,
      closeIcon: s,
      triggerIcon: l,
      showProductCountAsSuffix: r
    }) => {
      const [c, u] = x(!1), m = fi(), f = _e(
        a || {
          type: "image",
          src: "",
          alt: ""
        }
      ), h = (a == null ? void 0 : a.type) === "image" && f(De, t.boolean()), P = xt.styles(n), v = be("look"), y = k();
      if (!h || h.value !== !0 || !v.length)
        return null;
      const S = () => {
        ka.emit("featureInteraction", {
          feature: "shop_the_look",
          action: "clicked"
        });
      };
      return /* @__PURE__ */ d(
        A,
        {
          open: c,
          onOpenChange: u,
          direction: m ? "right" : "bottom",
          variants: {
            rounded: "subtle"
          },
          ...o,
          children: [
            /* @__PURE__ */ e(
              A.Trigger,
              {
                className: i || P.trigger,
                onClick: S,
                "aria-label": `Shop The Look - ${v.length} ${v.length === 1 ? "product" : "products"}`,
                children: /* @__PURE__ */ d("div", { className: P.triggerContent, children: [
                  y("Shop_The_Look_Trigger"),
                  l
                ] })
              }
            ),
            /* @__PURE__ */ d(A.Content, { children: [
              /* @__PURE__ */ e(A.Title, { hidden: !0, children: y("Shop_The_Look_Heading") }),
              /* @__PURE__ */ d("div", { className: P.wrapper, children: [
                /* @__PURE__ */ d("div", { className: P.header, children: [
                  /* @__PURE__ */ e(
                    _a,
                    {
                      heading: y("Shop_The_Look_Heading"),
                      suffix: r ? String(v.length) : void 0,
                      variants: { headingSize: "lg" }
                    }
                  ),
                  /* @__PURE__ */ e(A.Close, { className: P.close, children: s ?? y("Shop_The_Look_Close") })
                ] }),
                /* @__PURE__ */ e("div", { className: P.productList, children: v.map((w, N) => /* @__PURE__ */ e(
                  ya,
                  {
                    additionalData: {
                      source: "shop-the-look",
                      item_list_id: "shop-the-look",
                      item_list_name: "Shop The Look"
                    },
                    children: /* @__PURE__ */ e(
                      Ne,
                      {
                        product: w.product,
                        context: {
                          type: "plp",
                          listId: "shop-the-look",
                          listName: "Shop The Look",
                          position: N
                        },
                        children: /* @__PURE__ */ e(bi, {})
                      }
                    )
                  },
                  w.product.base.productId
                )) })
              ] })
            ] })
          ]
        }
      );
    }
  )
), Pe = t.object({
  template: t.literal("keen"),
  variants: t.custom().optional(),
  indicator: t.literal("number").or(t.literal("dots")).optional(),
  navigation: t.object({
    enabled: t.object({
      mobile: t.boolean().optional().default(!1),
      tablet: t.boolean().optional().default(!1),
      desktop: t.boolean().optional().default(!1)
    }),
    prevIcon: t.custom().optional(),
    nextIcon: t.custom().optional()
  }).optional(),
  slidesPerView: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  gap: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  children: t.custom().optional(),
  buttonInSlider: t.object({
    enabled: t.boolean().optional(),
    onClick: t.custom().optional(),
    label: t.string().optional()
  }).optional(),
  blueprint: t.custom().optional(),
  videoSettings: Sa.optional()
}), Pi = b(
  "ImageGalleryAsKeen",
  g(
    Pe,
    ({
      variants: a,
      indicator: i,
      navigation: n,
      slidesPerView: o,
      gap: s,
      children: l,
      buttonInSlider: r,
      videoSettings: c,
      ...u
    }) => {
      var W, ae, ie;
      const {
        content: { media: m }
      } = C(), h = (u.blueprint ?? Gt).styles(a), [P, v] = pe.useState(0);
      function y(_) {
        return (B) => {
          function G() {
            B.slides.forEach((M) => {
              M.classList.remove("active");
            });
          }
          function q(M) {
            B.slides[M].classList.add("active");
          }
          function Bt() {
            B.slides.forEach((M, ue) => {
              M.addEventListener("click", () => {
                _.current && _.current.moveToIdx(ue);
              });
            });
          }
          B.on("created", () => {
            _.current && (q(B.track.details.rel), Bt(), _.current.on("animationStarted", (M) => {
              G();
              const ue = M.animator.targetIdx || 0;
              q(M.track.absToRel(ue)), B.moveToIdx(Math.min(B.track.details.maxIdx, ue));
            }));
          });
        };
      }
      const S = Ge(m, {
        key: je,
        value: [!1, void 0]
      }), N = (S == null ? void 0 : S.length) === 1, D = pe.useMemo(
        () => S.map((_) => _.src).join(","),
        [S]
      ), [I, T] = xe({
        selector: ".keen-slider__slide",
        mode: "snap",
        loop: !N,
        breakpoints: {
          "(min-width: 0px)": {
            slides: {
              perView: N ? 1 : (o == null ? void 0 : o.mobile) ?? 1,
              spacing: (s == null ? void 0 : s.mobile) ?? 12
            }
          },
          "(min-width: 640px)": {
            slides: {
              perView: N ? 1 : (o == null ? void 0 : o.tablet) ?? 1,
              spacing: (s == null ? void 0 : s.tablet) ?? 24
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: N ? 1 : (o == null ? void 0 : o.desktop) ?? 1,
              spacing: (s == null ? void 0 : s.desktop) ?? 20
            }
          }
        },
        slideChanged(_) {
          v(_.track.details.rel);
        }
      });
      pe.useEffect(() => {
        v(0);
      }, [D]);
      const [K] = xe(
        {
          initial: 0,
          slides: {
            perView: "auto",
            spacing: 4
          }
        },
        [y(T)]
      ), Q = va({
        mobile: (W = n == null ? void 0 : n.enabled) == null ? void 0 : W.mobile,
        tablet: (ae = n == null ? void 0 : n.enabled) == null ? void 0 : ae.tablet,
        desktop: (ie = n == null ? void 0 : n.enabled) == null ? void 0 : ie.desktop
      });
      return /* @__PURE__ */ d(
        "div",
        {
          className: h.base,
          "data-button-in-slider": (r == null ? void 0 : r.enabled) ?? !1,
          children: [
            /* @__PURE__ */ e(Je, { className: h.bundleSavingsBadge }),
            /* @__PURE__ */ d(
              "div",
              {
                ref: I,
                className: `keen-slider ${h.galleryWrapper}`,
                children: [
                  l,
                  S.map((_, B) => _ ? /* @__PURE__ */ e(
                    vi,
                    {
                      media: _,
                      position: B,
                      index: B,
                      slots: h,
                      currentSlide: P,
                      videoSettings: c
                    },
                    `${_.src}-${B}`
                  ) : null),
                  (r == null ? void 0 : r.enabled) && (r == null ? void 0 : r.onClick) && (r == null ? void 0 : r.label) && /* @__PURE__ */ e(
                    "button",
                    {
                      className: h.linkButton,
                      onClick: r.onClick,
                      children: r.label
                    }
                  ),
                  i === "number" && /* @__PURE__ */ d("span", { className: h.numberIndicator, children: [
                    "[ ",
                    P + 1,
                    " / ",
                    S.length,
                    " ]"
                  ] }),
                  i === "dots" && /* @__PURE__ */ e("span", { className: h.dotsIndicatorWrapper, children: S.map((_, B) => /* @__PURE__ */ e(
                    "button",
                    {
                      "data-is-active": P === B ? "true" : "false",
                      onClick: () => {
                        var G;
                        return (G = T.current) == null ? void 0 : G.moveToIdx(B);
                      },
                      className: h.dotsIndicator
                    },
                    B
                  )) }),
                  !N && (n == null ? void 0 : n.prevIcon) && (n == null ? void 0 : n.nextIcon) && /* @__PURE__ */ d("div", { className: h.arrowsWrapper, ...Q, children: [
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: h.leftArrow,
                        onClick: () => {
                          var _;
                          return (_ = T.current) == null ? void 0 : _.prev();
                        },
                        children: n == null ? void 0 : n.prevIcon
                      }
                    ),
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: h.rightArrow,
                        onClick: () => {
                          var _;
                          return (_ = T.current) == null ? void 0 : _.next();
                        },
                        children: n == null ? void 0 : n.nextIcon
                      }
                    )
                  ] })
                ]
              },
              D
            ),
            S.length > 1 && /* @__PURE__ */ e(
              "div",
              {
                ref: K,
                className: `keen-slider thumbnail ${h.thumbnailWrapper}`,
                children: S.map((_, B) => /* @__PURE__ */ e(
                  "div",
                  {
                    "data-is-active": P === B ? "true" : "false",
                    className: `keen-slider__slide relative ${h.thumbnail}`,
                    children: _.type === "image" && /* @__PURE__ */ e(
                      V,
                      {
                        image: { src: _.src, alt: (_ == null ? void 0 : _.alt) ?? "dada" },
                        className: "w-full h-full"
                      }
                    )
                  },
                  `${_.src}-${B}`
                ))
              }
            )
          ]
        }
      );
    }
  )
), vi = ({
  currentSlide: a,
  position: i,
  index: n,
  media: o,
  slots: s,
  videoSettings: l
}) => {
  const r = a !== n, c = _e(o), u = o.type === "image" && c("model_is_wearing", t.string()), m = o.type === "image" && c(De, t.boolean());
  return o ? /* @__PURE__ */ d(
    "div",
    {
      "data-is-active": a === n ? "true" : "false",
      className: `keen-slider__slide ${s.imageWrapper} relative`,
      children: [
        u && /* @__PURE__ */ e("div", { className: s.modelIsWearing, children: u.value }),
        m && /* @__PURE__ */ e(Xe, { media: o, className: s.shopTheLook }),
        o.type === "image" ? /* @__PURE__ */ e(
          V,
          {
            image: { src: o.src, alt: o.alt },
            className: s.image,
            fetchpriority: i < 2 ? "high" : "auto",
            loading: i < 2 ? "eager" : "lazy",
            displaySize: {
              mobile: "50vw",
              tablet: "80vw",
              desktop: "40vw"
            }
          }
        ) : /* @__PURE__ */ e(Re, { src: o.src, loop: !0, autoPlay: !0, ...l }),
        r && /* @__PURE__ */ e("div", { className: s.peekingImage })
      ]
    },
    n
  ) : null;
}, et = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  imageSettings: Oe.optional()
}), Si = b(
  "ImageGalleryAsGrid",
  g(et, ({ variants: a, imageSettings: i }) => {
    const {
      content: { media: n }
    } = C(), o = Wt.styles(a), s = Ge(n, {
      key: je,
      value: [!1, void 0]
    });
    return /* @__PURE__ */ d("div", { className: o.base, children: [
      /* @__PURE__ */ e(Je, { className: o.bundleSavingsBadge }),
      s.map(
        (l, r) => l && /* @__PURE__ */ e(
          yi,
          {
            media: l,
            position: r,
            slots: o,
            imageSettings: i,
            amountOfImages: s.length
          },
          r
        )
      )
    ] });
  })
), yi = ({
  media: a,
  slots: i,
  position: n,
  amountOfImages: o,
  imageSettings: s
}) => {
  const l = _e(a), r = a.type === "image" && l("model_is_wearing", t.string()), c = a.type === "image" && l(De, t.boolean()), u = n === o - 1, m = o % 2 !== 0;
  return /* @__PURE__ */ d("div", { className: i.imageWrapper, children: [
    r && /* @__PURE__ */ e("div", { className: i.modelIsWearing, children: r.value }),
    c && /* @__PURE__ */ e(Xe, { media: a, className: i.shopTheLook }),
    a.type === "image" ? /* @__PURE__ */ e(
      V,
      {
        image: { src: a.src, alt: a.alt },
        className: i.image,
        fetchpriority: n < 5 ? "high" : "auto",
        loading: n < 5 ? "eager" : "lazy",
        displaySize: {
          mobile: "90vw",
          tablet: "90vw",
          desktop: m && u ? "60vw" : "25vw"
        },
        ...s
      }
    ) : /* @__PURE__ */ e(Re, { src: a.src, loop: !0, autoPlay: !0 })
  ] });
}, tt = t.discriminatedUnion("template", [
  Pe,
  et
]), wi = b(
  "ImageGallery",
  g(tt, (a) => a.template === "keen" ? /* @__PURE__ */ e(Pi, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Si, { ...a }) : null)
), at = t.object({
  template: t.literal("table"),
  variants: t.custom().optional(),
  groupId: t.string().optional(),
  content: t.object({
    heading: t.string().optional(),
    headingTag: t.union([
      t.literal("h1"),
      t.literal("h2"),
      t.literal("h3"),
      t.literal("h4"),
      t.literal("h5"),
      t.literal("h6")
    ]).optional()
  }).optional()
}), ki = b(
  "ProductSpecificationsAsTable",
  g(
    {
      schema: at,
      defaultProps: {
        template: "table",
        groupId: "pdp_specifications"
      }
    },
    ({ variants: a, content: i, groupId: n }) => {
      const o = Ot.styles(a), s = (i == null ? void 0 : i.headingTag) || "h3", l = ua(
        n ?? "pdp_specifications"
      );
      return !l || !l.length ? null : /* @__PURE__ */ d("div", { className: o.base, children: [
        (i == null ? void 0 : i.heading) && /* @__PURE__ */ e(s, { className: o.heading, children: i.heading }),
        /* @__PURE__ */ e("ol", { className: o.tableWrapper, children: l.map((r, c) => /* @__PURE__ */ d("li", { className: o.row, children: [
          /* @__PURE__ */ d("span", { className: o.label, children: [
            (r == null ? void 0 : r.icon) && /* @__PURE__ */ e("span", { className: o.icon, children: r.icon }),
            r.label
          ] }),
          /* @__PURE__ */ e("span", { className: o.value, children: r.value })
        ] }, c)) })
      ] });
    }
  )
), it = t.discriminatedUnion("template", [
  at
]), _i = b(
  "ProductSpecifications",
  g(it, (a) => a.template === "table" ? /* @__PURE__ */ e(ki, { ...a }) : null)
), Ni = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), Ie = t.object({
  template: t.literal("progress-bar"),
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional(),
  items: Ni.array().optional()
}), Ti = b(
  "AttributesAsProgressBar",
  g(
    Ie,
    ({
      variants: a,
      features: i = {
        onAScaleOf: 10
      },
      items: n
    }) => {
      const o = Rt.styles(a), s = C(), l = H(s);
      if (!n)
        return null;
      const r = n.map((c) => {
        var m;
        const u = (m = l(c.attributeKey, t.string())) == null ? void 0 : m.value;
        if (u)
          return {
            label: c.label,
            score: parseInt(u),
            barColor: c.barColor
          };
      }).filter(Na);
      return r.length === 0 ? null : /* @__PURE__ */ e("div", { className: o.base, children: r.map((c, u) => /* @__PURE__ */ d("div", { className: o.item, children: [
        /* @__PURE__ */ e("div", { className: o.label, children: c.label }),
        /* @__PURE__ */ e("div", { className: o.bar, children: /* @__PURE__ */ e(
          E.div,
          {
            className: o.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${c.score / i.onAScaleOf * 100}%`
            },
            exit: { width: 0 },
            transition: { delay: u * 0.16 },
            style: {
              backgroundColor: c.barColor
            }
          }
        ) }),
        /* @__PURE__ */ d("div", { className: o.scoreLabel, children: [
          c.score,
          "/",
          i.onAScaleOf
        ] })
      ] }, u)) });
    }
  )
), To = t.string(), ze = t.object({
  template: t.literal("tags"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional()
}), Bi = b(
  "AttributesAsTags",
  g(ze, ({ variants: a, attributeKey: i, label: n }) => {
    const o = jt.styles(a), s = z(
      i,
      t.union([
        t.string(),
        t.array(t.string()),
        t.array(t.object({ description: t.string() }))
      ])
    );
    if (!s)
      return null;
    const l = Array.isArray(s.value) ? s.value : [s.value];
    return l.length ? /* @__PURE__ */ d("div", { className: o.base, children: [
      n && /* @__PURE__ */ e("span", { className: o.label, children: n }),
      /* @__PURE__ */ e("div", { className: o.tags, children: l.map((r, c) => /* @__PURE__ */ e("div", { className: o.tag, children: typeof r == "object" ? r.description : r }, `${r}-${c}`)) })
    ] }) : null;
  })
), nt = t.object({
  template: t.literal("icon-blocks"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional(),
  link: Ta.optional()
}), Ci = b(
  "AttributesAsIconBlocks",
  g(
    nt,
    ({ variants: a, attributeKey: i, label: n, link: o }) => {
      var r, c;
      const s = Kt.styles(a), l = (r = z(
        i,
        t.array(
          t.object({
            description: t.string().optional(),
            image: t.object({
              url: t.string()
            }).optional()
          })
        )
      )) == null ? void 0 : r.value;
      if (l)
        return /* @__PURE__ */ d("div", { className: s.base, children: [
          /* @__PURE__ */ d("div", { className: s.header, children: [
            n && /* @__PURE__ */ e("span", { className: s.label, children: n }),
            ((c = o == null ? void 0 : o.link) == null ? void 0 : c.href) && /* @__PURE__ */ e(Ba, { as: "a", className: s.link, ...o })
          ] }),
          /* @__PURE__ */ e("div", { className: s.blocks, children: l.map(
            (u, m) => {
              var f;
              return (f = u.image) != null && f.url ? /* @__PURE__ */ d(
                "div",
                {
                  className: s.block,
                  children: [
                    /* @__PURE__ */ e(
                      V,
                      {
                        className: s.icon,
                        image: {
                          src: u.image.url,
                          alt: u.description
                        }
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: s.description, children: u.description })
                  ]
                },
                `${u.description}-${m}`
              ) : null;
            }
          ) })
        ] });
    }
  )
), ot = t.object({
  template: t.literal("row"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string().optional(),
  data: t.object({
    attributeLabel: t.string().optional(),
    value: t.string().optional()
  }).optional()
}), Ai = b(
  "AttributesAsRow",
  g(ot, ({ variants: a, attributeKey: i, data: n }) => {
    const o = Mt.styles(a), s = k(), l = z(i || "", t.string()), { attributeLabel: r, value: c } = l || n || {};
    return !l && !n ? null : /* @__PURE__ */ d("div", { className: o.base, children: [
      r && /* @__PURE__ */ e("label", { className: o.label, children: s(r) }),
      /* @__PURE__ */ e("h4", { className: o.value, children: c })
    ] });
  })
), Di = t.discriminatedUnion("template", [
  Ie,
  ze,
  nt,
  ot
]), Ii = b(
  "ProductAttributes",
  g(Di, (a) => a.template === "progress-bar" ? /* @__PURE__ */ e(Ti, { ...a }) : a.template === "tags" ? /* @__PURE__ */ e(Bi, { ...a }) : a.template === "icon-blocks" ? /* @__PURE__ */ e(Ci, { ...a }) : a.template === "row" ? /* @__PURE__ */ e(Ai, { ...a }) : null)
), zi = ({ className: a }) => /* @__PURE__ */ d(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), Li = ({ className: a }) => /* @__PURE__ */ d(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), xi = t.object({
  setDisplayGoToCheckoutButton: t.custom(),
  amount: t.number(),
  slots: t.custom(),
  increaseButtonSettings: X.optional(),
  decreaseButtonSettings: X.optional()
}), Gi = b(
  "AddToCartQuanityPickerRow",
  g(
    xi,
    ({
      setDisplayGoToCheckoutButton: a,
      slots: i,
      amount: n,
      decreaseButtonSettings: o,
      increaseButtonSettings: s
    }) => {
      const {
        addToCartMethod: l,
        removeFromCartMethod: r,
        quantityInCart: c,
        isAvailable: u
      } = fe(), m = k();
      function f(h) {
        l.execute(h), a(!0);
      }
      return /* @__PURE__ */ d("div", { className: i.quantityPickerWrapper, children: [
        /* @__PURE__ */ e(
          oe,
          {
            ...o,
            disabled: c < n,
            progress: r.loadingState,
            onClick: () => r.execute(n)
          }
        ),
        /* @__PURE__ */ d("div", { className: i.quantityDisplay, children: [
          /* @__PURE__ */ e("span", { className: i.quantityText, children: n }),
          /* @__PURE__ */ e("span", { className: i.quantityUnit, children: m("PDP_Quantity_Picker_Suffix") })
        ] }),
        /* @__PURE__ */ e(
          oe,
          {
            ...s,
            progress: l.loadingState,
            disabled: !u,
            onClick: () => f(n)
          }
        )
      ] });
    }
  )
), st = t.object({
  template: t.literal("quantity-picker"),
  variants: t.custom().optional(),
  features: t.object({
    increaseButtonSettings: X.optional(),
    decreaseButtonSettings: X.optional(),
    itemSuffix: t.string().optional(),
    /** An optional boolean that determines whether the price should be displayed. @default true */
    showPrice: t.boolean().optional(),
    /** An optional array of numbers that defines the quantity options for adding items to the cart @default [1, 10] */
    addQuantityOptions: t.array(t.number()).optional(),
    postAddAction: t.union([t.literal("goToCheckoutButton"), t.literal("none")]).optional()
  }).optional()
}), Wi = b(
  "AddToCartQuantityPicker",
  g(
    {
      schema: st,
      defaultProps: {
        template: "quantity-picker",
        features: {
          showPrice: !0,
          addQuantityOptions: [1, 10],
          postAddAction: "goToCheckoutButton",
          increaseButtonSettings: {
            variants: {
              width: "auto",
              size: "md",
              color: "primary"
            },
            iconRight: /* @__PURE__ */ e(Li, { className: "w-3 h-3" }),
            label: "Add"
          },
          decreaseButtonSettings: {
            variants: {
              width: "same-as-height",
              size: "md",
              color: "white"
            },
            iconLeft: /* @__PURE__ */ e(zi, { className: "w-3 h-3" })
          }
        }
      }
    },
    ({ variants: a, features: i }) => {
      var y;
      const n = le(), o = Et.styles(a), [s, l] = x(!1), r = k(), [c, u] = x(0);
      ye(null);
      const {
        addToCartMethod: m,
        removeFromCartMethod: f,
        quantityInCart: h,
        isAvailable: P
      } = fe(), v = () => {
        c && (c > h ? (m.execute(c - h), l(!0)) : c < h && f.execute(h - c));
      };
      return L(() => {
        u(0);
      }, [h]), /* @__PURE__ */ d("div", { className: o.base, children: [
        /* @__PURE__ */ d("div", { className: o.innerWrapper, children: [
          (i == null ? void 0 : i.showPrice) && /* @__PURE__ */ d(R, { children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: o.priceTag,
                "data-is-discounted": n.discountInfo ? "true" : "false",
                children: n.price.formatted
              }
            ),
            n.discountInfo && /* @__PURE__ */ e("span", { className: o.oldPriceTag, children: n.priceWithoutDiscount.formatted })
          ] }),
          /* @__PURE__ */ e("div", { className: o.currentQuantityWrapper, children: /* @__PURE__ */ d("div", { className: o.currentQuantityInputWrapper, children: [
            /* @__PURE__ */ e(
              "form",
              {
                onSubmit: (S) => {
                  S.preventDefault(), v();
                },
                children: /* @__PURE__ */ e(
                  "input",
                  {
                    onChange: (S) => {
                      S.preventDefault(), u(parseInt(S.target.value));
                    },
                    value: c > 0 ? c : "",
                    className: o.currentQuantityInput,
                    placeholder: h.toString(),
                    min: "0",
                    type: "number",
                    enterKeyHint: "done",
                    autoComplete: "off",
                    autoCorrect: "off",
                    spellCheck: "false"
                  }
                )
              }
            ),
            c > 0 ? /* @__PURE__ */ e(
              oe,
              {
                disabled: !P,
                onClick: v,
                className: o.updateButton,
                progress: c > h ? m.loadingState : f.loadingState,
                variants: {
                  size: "md",
                  width: "same-as-height"
                },
                label: r("PDP_Quantity_Picker_Update")
              }
            ) : /* @__PURE__ */ e("span", { className: o.currentQuantityUnit, children: r("PDP_Quantity_Picker_Suffix") })
          ] }) }),
          /* @__PURE__ */ e("div", { className: o.quantityPickersWrapper, children: (y = i == null ? void 0 : i.addQuantityOptions) == null ? void 0 : y.map((S, w) => /* @__PURE__ */ e(
            Gi,
            {
              increaseButtonSettings: i.increaseButtonSettings,
              decreaseButtonSettings: i.decreaseButtonSettings,
              amount: S,
              slots: o,
              setDisplayGoToCheckoutButton: l
            },
            w
          )) })
        ] }),
        /* @__PURE__ */ e(J, { children: s && /* @__PURE__ */ e(
          E.div,
          {
            initial: { marginTop: -50 },
            animate: { marginTop: 0 },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ e(
              $,
              {
                as: "a",
                variants: {
                  width: "full",
                  style: "solid",
                  color: "black"
                },
                label: r("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), rt = {
  available: "PDP_Add_To_Cart",
  "out-of-stock": "PDP_Out_Of_Stock",
  discontinued: "PDP_Discontinued",
  "not-determined": "PDP_Select_Size"
}, Oi = (a) => {
  const i = ge(), n = k(), o = i.status === "out-of-stock" && a ? n("Notify_Me_Submit_Label") : n(rt[i.status]) ?? "PDP_Select_Size";
  return n(o);
}, lt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: X.optional(),
  animateAddToCartLabel: t.boolean().optional(),
  postAddAction: t.union([
    t.literal("goToCheckoutButton"),
    t.literal("showMinicart"),
    t.literal("none")
  ]).optional(),
  isNotifyMeEnabled: t.boolean().optional()
}), Ri = b(
  "AddToCartButton",
  g(
    {
      schema: lt,
      defaultProps: {
        template: "button",
        animateAddToCartLabel: !0,
        postAddAction: "showMinicart",
        isNotifyMeEnabled: !1
      }
    },
    ({
      variants: a,
      buttonSettings: i,
      animateAddToCartLabel: n,
      postAddAction: o,
      isNotifyMeEnabled: s
    }) => {
      const l = Ht.styles(a), { addToCartMethod: r, isAvailable: c, isOutOfStock: u, isDiscontinued: m } = fe(), f = u && s, h = Oi(f), P = k(), v = typeof window < "u" && window.location.pathname.includes("/checkout"), [y, S] = x(!1), w = we(async () => {
        if (!m) {
          if (u && s) {
            Y.emit("open", { overlayId: "notify-me" });
            return;
          } else if (!c) {
            za.error(P("Add_To_Cart_Error_Not_Available_Toast"));
            return;
          }
          await r.execute(), o === "goToCheckoutButton" && S(!0), o === "showMinicart" && !v && Y.emit("open", { overlayId: "mini-cart" });
        }
      }, [
        u,
        s,
        r,
        o,
        P,
        v
      ]), N = At(
        () => n ? /* @__PURE__ */ e(J, { mode: "wait", initial: !1, children: /* @__PURE__ */ e(
          E.span,
          {
            exit: {
              y: "-190%",
              opacity: 0.7,
              transition: {
                duration: 0.15
              }
            },
            initial: {
              y: "150%",
              opacity: 0.7
            },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                duration: 0.15
              }
            },
            children: h
          },
          h
        ) }) : h,
        [n, h]
      );
      return /* @__PURE__ */ d("div", { className: l.base, id: "add-to-cart-component", children: [
        /* @__PURE__ */ e(
          $,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...i,
            progress: r.loadingState,
            dataAttr: {
              "appear-disabled": (u || m) && !f
            },
            "aria-disabled": !c && !f ? "true" : "false",
            label: N,
            onClick: w
          }
        ),
        /* @__PURE__ */ e(J, { initial: !1, children: y && /* @__PURE__ */ e(
          E.div,
          {
            initial: { y: "-100%" },
            animate: { y: 0 },
            transition: {
              duration: 0.5,
              ease: Me(0.32, 0.72, 0, 1)
            },
            children: /* @__PURE__ */ e(
              $,
              {
                as: "a",
                variants: {
                  width: "full",
                  color: "black",
                  style: "outline"
                },
                label: P("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), ct = t.discriminatedUnion("template", [
  st,
  lt
]), ji = b(
  "ProductAddToCart",
  g(ct, (a) => O() === "bundle" ? null : a.template === "button" ? /* @__PURE__ */ e(Ri, { ...a }) : a.template === "quantity-picker" ? /* @__PURE__ */ e(Wi, { ...a }) : null)
), ce = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  notifyMe: t.object({
    enabled: t.boolean().optional(),
    icon: t.custom().optional()
  }).optional(),
  lowStockIndicator: t.object({
    /**
     * Enables/disables the low stock indicator functionality
     * @default false
     */
    enabled: t.boolean().optional(),
    /**
     * Threshold value below which stock is considered low
     * Triggers visual indicator when stock drops below this number
     * @default 5
     */
    lowStockLimit: t.number().optional()
  }).optional(),
  headerContent: t.custom().optional()
}), Ki = b(
  "SizePickerButtonGrid",
  g(
    ce,
    ({ variants: a, notifyMe: i, lowStockIndicator: n, headerContent: o }) => {
      var f;
      const s = Vt.styles(a), { optionGroups: l, selectOption: r, selectedOptions: c } = Te(), u = k(), m = l.length === 1 && ((f = l[0]) == null ? void 0 : f.options.length) === 1;
      return m ? null : (L(() => {
        var h;
        m && ((h = l[0]) != null && h.options[0]) && r(
          l[0].dimensionKey,
          l[0].options[0]
        );
      }, []), /* @__PURE__ */ d("div", { className: s.base, children: [
        /* @__PURE__ */ d("div", { className: s.header, children: [
          /* @__PURE__ */ e("span", { children: u("PDP_Size_Picker_Select_Size") }),
          o
        ] }),
        l.map((h) => /* @__PURE__ */ e("div", { className: s.wrapper, children: h.options.map((P) => {
          var N;
          const v = ((N = c[h.dimensionKey]) == null ? void 0 : N.dimensionValue) === P.dimensionValue, y = P.inventory.inStock, S = y && P.inventory.quantity < ((n == null ? void 0 : n.lowStockLimit) ?? 5), w = () => {
            r(h.dimensionKey, P);
          };
          return /* @__PURE__ */ d(
            "button",
            {
              type: "button",
              "data-is-selected": v ? "true" : "false",
              "data-is-out-of-stock": y ? "false" : "true",
              disabled: !y && !(i != null && i.enabled),
              className: s.size,
              "aria-label": P.label,
              onClick: w,
              children: [
                S && (n == null ? void 0 : n.enabled) && /* @__PURE__ */ e("span", { className: s.lowStockIndicator }),
                (i == null ? void 0 : i.enabled) && !y && i.icon,
                P.label
              ]
            },
            P.dimensionValue
          );
        }) }, h.dimensionKey))
      ] }));
    }
  )
), Mi = {
  direction: "right",
  variants: {
    rounded: "none"
  }
}, Ei = {
  style: "outline",
  width: "full"
}, se = t.object({
  template: t.literal("modal"),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttonVariants: t.custom().optional().describe("Variants for the button"),
  triggerLabel: t.string().optional(),
  sizeButtons: ke.optional(),
  aboveButtonComponent: t.custom().optional(),
  belowButtonComponent: t.custom().optional(),
  customOverlayId: t.string().optional()
}), Hi = () => {
  const [a, i] = x(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return L(() => {
    const n = () => {
      i(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, Vi = b(
  "SizePickerModal",
  g(
    {
      schema: se,
      defaultProps: {
        template: "modal",
        drawerSettings: Mi,
        buttonVariants: Ei,
        sizeButtons: {
          variants: {
            rounded: "full",
            width: "same-as-height",
            size: "md",
            color: "black",
            style: "outline"
          }
        },
        customOverlayId: "size-picker-modal"
      }
    },
    ({
      variants: a,
      drawerSettings: i,
      buttonVariants: n,
      triggerLabel: o,
      sizeButtons: s,
      aboveButtonComponent: l,
      belowButtonComponent: r,
      customOverlayId: c
    }) => {
      const u = k(), m = Hi(), f = $t.styles(a), { optionGroups: h, selectOption: P, selectedOptions: v } = Te();
      return /* @__PURE__ */ d(
        A,
        {
          hasOverlay: !0,
          ...i,
          variants: {
            direction: m ? "right" : "bottom",
            ...(i ?? {}).variants
          },
          customOverlayId: c ?? "size-picker-modal",
          direction: m ? "right" : "bottom",
          children: [
            /* @__PURE__ */ e(A.Trigger, { className: f.trigger, children: /* @__PURE__ */ e(
              Ee,
              {
                label: o ?? u("Size_Picker_Select_Size"),
                variants: n
              }
            ) }),
            /* @__PURE__ */ d(A.Content, { children: [
              /* @__PURE__ */ e("div", { className: f.optionsWrapper, children: h.map((y) => /* @__PURE__ */ d(
                "div",
                {
                  className: f.wrapper,
                  "data-dimension-key": y.dimensionKey,
                  "data-dimension-label": y.dimensionLabel,
                  children: [
                    /* @__PURE__ */ e("div", { className: f.header, children: /* @__PURE__ */ e("h3", { className: f.heading, children: u(`Size_Picker_${y.dimensionLabel}`) }) }),
                    /* @__PURE__ */ e("div", { className: f.sizeWrapper, children: y.options.map((S, w) => {
                      var D;
                      const N = ((D = v[y.dimensionKey]) == null ? void 0 : D.dimensionValue) === S.dimensionValue;
                      return /* @__PURE__ */ e(
                        oe,
                        {
                          dataAttr: {
                            "is-selected": N,
                            "is-out-of-stock": !S.inventory.inStock
                          },
                          className: f.size,
                          onClick: () => P(y.dimensionKey, S),
                          label: S.label,
                          ...s
                        },
                        `${S.label}-${w}`
                      );
                    }) })
                  ]
                },
                y.dimensionKey
              )) }),
              l,
              /* @__PURE__ */ e(p.AddToCart, { template: "button" }),
              r
            ] })
          ]
        }
      );
    }
  )
), $i = t.discriminatedUnion("template", [
  ce,
  se
]), Ui = b(
  "ProductSizePicker",
  g($i, (a) => O() !== "with_variants" ? null : a.template === "button-grid" ? /* @__PURE__ */ e(Ki, { ...a }) : a.template === "modal" ? /* @__PURE__ */ e(Vi, { ...a }) : null)
), Le = t.object({
  template: t.literal("image-card"),
  colorAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  hide: t.boolean().optional()
}), Fi = b(
  "SiblingsImageCard",
  g(
    {
      schema: Le,
      defaultProps: {
        template: "image-card",
        colorAttributeKey: "product_color",
        headingTag: "h2"
      }
    },
    ({ variants: a, colorAttributeKey: i, headingTag: n }) => {
      const o = k(), s = Ut.styles(a), l = z(
        i ?? "",
        t.string()
      ), r = C(), c = We(), u = n ?? "h2";
      return c.length ? /* @__PURE__ */ d("div", { className: s.base, children: [
        l && /* @__PURE__ */ e(u, { className: s.header, children: o("PDP_Siblings_Header_Title", {
          color: l.value,
          colorName: l.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: s.siblingsWrapper, children: c.map((m, f) => {
          var h, P, v, y, S, w;
          return (v = (P = (h = m.content) == null ? void 0 : h.media) == null ? void 0 : P[0]) != null && v.src ? /* @__PURE__ */ e(
            re,
            {
              productBase: m,
              context: "product-sibling",
              className: s.sibling,
              "data-is-selected": m.productId === r.productId,
              children: /* @__PURE__ */ e(
                V,
                {
                  image: { src: (w = (S = (y = m.content) == null ? void 0 : y.media) == null ? void 0 : S[0]) == null ? void 0 : w.src },
                  displaySize: {
                    mobile: "80px",
                    tablet: "80px",
                    desktop: "80px"
                  },
                  className: s.siblingImage
                }
              )
            },
            f
          ) : null;
        }) })
      ] }) : null;
    }
  )
), Qi = (a) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(a), qi = (a) => /^[a-zA-Z]+$/.test(a) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(a), Zi = (a) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(a) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(a), Yi = (a) => a.startsWith("http") || a.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(a), dt = ({
  sibling: a,
  colorSwatchAttributeKey: i,
  className: n
}) => {
  const o = C(), s = H(a);
  if (!i)
    return null;
  const l = s(
    i,
    t.string()
  );
  if (!(l != null && l.valueLabel))
    return null;
  const r = l.valueLabel, c = l.value, u = () => c ? Yi(c) ? {
    backgroundImage: `url(${c})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : Qi(c) || qi(c) || Zi(c) ? { backgroundColor: c } : { backgroundColor: "#cccccc" } : {}, m = `${r || ""} color option`;
  return /* @__PURE__ */ e(
    re,
    {
      productBase: a,
      context: "product-sibling",
      className: n,
      style: u(),
      "data-is-selected": o.productId === a.productId,
      "data-is-white": c === "#ffffff" || (r == null ? void 0 : r.toLocaleLowerCase()) === "white" || (r == null ? void 0 : r.toLocaleLowerCase()) === "vit",
      "aria-label": m,
      title: r || "",
      role: "button",
      "data-testid": `color-swatch-${r == null ? void 0 : r.toLowerCase().replace(/\s+/g, "-")}`
    },
    a.productKey
  );
}, ut = t.object({
  template: t.literal("color-swatch"),
  colorSwatchAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  hide: t.boolean().optional()
}), Ji = b(
  "SiblingColorSwatchList",
  g(
    {
      schema: ut,
      defaultProps: {
        template: "color-swatch",
        colorSwatchAttributeKey: "product_color"
      }
    },
    ({ variants: a, colorSwatchAttributeKey: i }) => {
      const n = Ft.styles(a), o = C(), s = k(), l = We(), r = H(o);
      if (!i || !l.length)
        return null;
      const c = r(
        i,
        t.string()
      );
      return c ? /* @__PURE__ */ d("div", { className: n.base, children: [
        /* @__PURE__ */ e("div", { className: n.header, children: s("PDP_Product_ColorSwatch_Label", {
          color: c.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: n.siblingsWrapper, children: l.map((u, m) => /* @__PURE__ */ e(
          dt,
          {
            sibling: u,
            colorSwatchAttributeKey: i,
            className: n.sibling
          },
          `sibling.productKey-${m}`
        )) })
      ] }) : null;
    }
  )
), de = t.discriminatedUnion("template", [
  Le,
  ut
]), Xi = b(
  "ProductSiblings",
  g(de, (a) => a.hide === !0 ? null : a.template === "image-card" ? /* @__PURE__ */ e(Fi, { ...a }) : a.template === "color-swatch" ? /* @__PURE__ */ e(Ji, { ...a }) : null)
), pt = t.object({
  template: t.literal("image-cards"),
  swiperSettings: Ve.optional(),
  relationType: t.string().optional(),
  productCardSettings: La.optional()
}), en = (a) => {
  const i = Ga(), n = k();
  if (!i || i.length === 0)
    return null;
  const o = Qt.styles();
  return /* @__PURE__ */ d("div", { className: o.base, children: [
    /* @__PURE__ */ e("h3", { className: o.heading, children: n("PDP_Related_Products_Image_Cards_Heading") }),
    /* @__PURE__ */ e("div", { className: o.wrapper, children: i.slice(0, 3).map((s, l) => s.type !== "product" ? null : /* @__PURE__ */ e(
      Ne,
      {
        product: s.product,
        context: {
          type: "plp",
          listId: "related-products",
          listName: "Related Products",
          position: l
        },
        children: /* @__PURE__ */ e(xa, { templateProps: a.productCardSettings })
      },
      l
    )) })
  ] });
}, mt = b(
  "ProductRelatedProductsImageCards",
  g(pt, ({ relationType: a, ...i }) => {
    const n = be(a);
    if (!mt.length)
      return null;
    const o = {
      items: n.map((s) => ({ type: "product", product: s.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      facets: [],
      sort: []
    };
    return /* @__PURE__ */ e(He, { result: o, children: /* @__PURE__ */ e(en, { ...i }) });
  })
), ht = t.object({
  template: t.literal("swiper"),
  swiperSettings: Ve.optional(),
  relationType: t.string().optional()
}), tn = b(
  "ProductRelatedProductsSwiper",
  g(ht, ({ swiperSettings: a, relationType: i }) => {
    const n = be(i);
    if (!n.length)
      return null;
    const o = {
      items: n.map((s) => ({ type: "product", product: s.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      sort: [],
      facets: []
    };
    return /* @__PURE__ */ e(He, { result: o, children: /* @__PURE__ */ e(Wa, { ...a }) });
  })
), F = t.discriminatedUnion("template", [
  pt,
  ht
]), an = b(
  "RelatedProducts",
  g(F, (a) => a.template === "image-cards" ? /* @__PURE__ */ e(mt, { ...a }) : a.template === "swiper" ? /* @__PURE__ */ e(tn, { ...a }) : null)
), nn = ({
  targetSelector: a,
  mode: i = "isNotVisible"
}) => {
  const [n, o] = x(!1), s = ye(null), l = ye(null);
  L(() => {
    if (i === "isAlwaysVisible") {
      o(!0);
      return;
    } else if (i === "isAlwaysHidden") {
      o(!1);
      return;
    }
  }, [i]);
  const r = we(() => {
    if (!s.current)
      return;
    const u = s.current.getBoundingClientRect();
    switch (i) {
      case "isScrolledPast":
        o(u.bottom <= 0);
        break;
      case "isBeforeView":
        o(u.top >= window.innerHeight);
        break;
    }
  }, [i]), c = we(() => {
    l.current && cancelAnimationFrame(l.current), l.current = requestAnimationFrame(() => {
      r(), l.current = null;
    });
  }, [r]);
  return L(() => {
    if (i === "isAlwaysVisible" || i === "isAlwaysHidden" || (s.current = document.querySelector(a), !s.current))
      return;
    let u = null;
    return i === "isVisible" || i === "isNotVisible" ? (u = new IntersectionObserver(
      ([m]) => {
        m && o(
          i === "isVisible" ? m.isIntersecting : !m.isIntersecting
        );
      },
      { threshold: 0.1 }
    ), u.observe(s.current)) : (r(), window.addEventListener("scroll", c, { passive: !0 }), window.addEventListener("resize", c, { passive: !0 })), () => {
      u ? u.disconnect() : (window.removeEventListener("scroll", c), window.removeEventListener("resize", c)), l.current && cancelAnimationFrame(l.current);
    };
  }, [a, i, r, c]), n;
}, bt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: X.optional(),
  mode: t.custom().optional(),
  targetSelector: t.string().optional(),
  selectSizeAction: t.union([t.literal("open-size-picker"), t.literal("scroll-to-size-picker")]).optional(),
  withSizePicker: t.boolean().optional(),
  sizePickerOverlayId: t.string().optional(),
  showPrice: t.boolean().optional()
}), on = b(
  "StickyAddToCartButton",
  g(
    {
      schema: bt,
      defaultProps: {
        template: "button",
        mode: "isScrolledPast",
        targetSelector: "#add-to-cart-component",
        selectSizeAction: "scroll-to-size-picker",
        withSizePicker: !1,
        sizePickerOverlayId: "size-picker-modal",
        showPrice: !0
      }
    },
    ({
      variants: a,
      buttonSettings: i,
      mode: n,
      targetSelector: o,
      selectSizeAction: s,
      withSizePicker: l,
      sizePickerOverlayId: r,
      showPrice: c
    }) => {
      const u = qt.styles(a), { addToCartMethod: m, isAvailable: f } = fe(), h = ge(), P = k(), { selectedOptions: v } = Te(), y = Object.values(v).filter((T) => !!T).map((T) => T.label).join(" / "), S = le(), w = nn({
        targetSelector: o ?? "#add-to-cart-component",
        mode: n
      }), N = typeof window < "u" && window.location.pathname.includes("/checkout"), D = () => {
        Y.emit("open", {
          overlayId: r ?? "size-picker-modal"
        });
      }, I = async () => {
        if (!f) {
          if (s === "open-size-picker") {
            D();
            return;
          }
          if (s === "scroll-to-size-picker") {
            const T = document.getElementById("add-to-cart-component");
            T == null || T.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            return;
          }
        }
        await m.execute(), N || Y.emit("open", { overlayId: "mini-cart" });
      };
      return h.status === "out-of-stock" ? null : l ? /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": w ? "true" : "false",
          children: /* @__PURE__ */ d("div", { className: u.buttonsWrapper, children: [
            /* @__PURE__ */ e(
              $,
              {
                as: "button",
                variants: {
                  width: "full",
                  style: "outline",
                  color: "black"
                },
                label: f ? y : P("PDP_Select_Size"),
                onClick: D
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                as: "button",
                variants: {
                  width: "full"
                },
                ...i,
                progress: m.loadingState,
                label: /* @__PURE__ */ d(R, { children: [
                  P("PDP_Add_To_Cart"),
                  c && /* @__PURE__ */ d(R, { children: [
                    " ",
                    /* @__PURE__ */ e("span", { children: S.price.formatted })
                  ] })
                ] }),
                onClick: I
              }
            )
          ] })
        }
      ) : /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": w ? "true" : "false",
          children: /* @__PURE__ */ e(
            $,
            {
              as: "button",
              variants: {
                width: "full",
                justifyContent: "between"
              },
              ...i,
              progress: m.loadingState,
              label: /* @__PURE__ */ d(R, { children: [
                P(f ? "PDP_Add_To_Cart" : "PDP_Select_Size"),
                c && /* @__PURE__ */ d(R, { children: [
                  " ",
                  /* @__PURE__ */ e("span", { children: S.price.formatted })
                ] })
              ] }),
              onClick: I
            }
          )
        }
      );
    }
  )
), sn = t.discriminatedUnion("template", [
  bt
]), rn = b(
  "ProductStickyAddToCart",
  g(sn, (a) => O() !== "with_variants" ? null : a.template === "button" ? /* @__PURE__ */ e(on, { ...a }) : null)
), ln = () => O() !== "bundle" ? null : /* @__PURE__ */ e(cn, {}), cn = () => {
  const { sections: a } = Be(), i = me.styles();
  return /* @__PURE__ */ d("div", { className: i.base, children: [
    /* @__PURE__ */ e("div", { className: i.sectionsWrapper, children: Object.values(a).map((n, o) => /* @__PURE__ */ e(
      Ne,
      {
        product: n.activeProduct.product,
        context: {
          type: "plp",
          listId: "bundle-section",
          listName: "Bundle Section",
          position: o
        },
        children: /* @__PURE__ */ e(dn, { section: n, index: o })
      },
      o
    )) }),
    /* @__PURE__ */ e(mn, {}),
    /* @__PURE__ */ e(hn, {})
  ] });
}, dn = ({
  section: a,
  index: i
}) => {
  const n = C(), { selectSectionProduct: o } = Be(), s = me.styles(), l = k(), r = (c) => {
    o(a.sectionId, c);
  };
  return /* @__PURE__ */ d("div", { className: s.section, children: [
    /* @__PURE__ */ e(J, { mode: "wait", initial: !1, children: /* @__PURE__ */ e("div", { className: s.productNameWrapper, children: /* @__PURE__ */ e(
      E.h3,
      {
        className: s.productName,
        exit: {
          y: "-100%"
        },
        initial: {
          y: "100%"
        },
        animate: {
          y: 0
        },
        transition: {
          duration: 0.35,
          ease: Me(0.32, 0.72, 0, 1)
        },
        children: l("PDP_Bundle_Selection_Product", {
          index: i + 1,
          product: n.content.name
        })
      }
    ) }, n.content.name) }),
    /* @__PURE__ */ e("h3", { className: s.selectionHeading, children: l("PDP_Bundle_Selection_Heading") }),
    /* @__PURE__ */ e("div", { className: s.productSlider, children: a.products.map((c, u) => {
      const m = c.base.productId === a.activeProduct.product.base.productId;
      return /* @__PURE__ */ e(
        un,
        {
          product: c,
          isSelected: m,
          onClick: () => r(c)
        },
        u
      );
    }) }),
    /* @__PURE__ */ e(pn, { sectionId: a.sectionId }),
    /* @__PURE__ */ e(
      Ca,
      {
        link: { href: a.activeProduct.product.base.slug },
        label: l("PDP_Bundle_Selection_Link"),
        className: s.link
      }
    )
  ] });
}, un = ({
  product: a,
  isSelected: i,
  onClick: n
}) => {
  var c;
  const o = me.styles(), s = (c = a.base.content.media) == null ? void 0 : c[0], r = H(a.base)("product_color", t.string());
  return /* @__PURE__ */ d(
    "button",
    {
      className: o.productWrapper,
      onClick: n,
      "data-is-selected": i ? "true" : "false",
      children: [
        s && /* @__PURE__ */ e(V, { className: o.productImage, image: s }),
        r && /* @__PURE__ */ d("div", { className: o.swatchWrapper, children: [
          /* @__PURE__ */ e(
            dt,
            {
              sibling: a.base,
              colorSwatchAttributeKey: "colorSwatch",
              className: o.swatch
            }
          ),
          /* @__PURE__ */ e("span", { className: o.swatchLabel, children: r == null ? void 0 : r.valueLabel })
        ] })
      ]
    }
  );
}, pn = ({ sectionId: a }) => {
  const i = O(), n = ge(), { selectSectionSize: o } = Be(), s = k(), l = n.status === "available" ? n.availableItemId : void 0;
  switch (L(() => {
    o(a, l);
  }, [l]), i) {
    case "with_variants":
      return /* @__PURE__ */ e(p.SizePicker, { template: "button-grid" });
    case "simple":
      return /* @__PURE__ */ e(
        "button",
        {
          "data-is-selected": n.status === "out-of-stock" ? "false" : "true",
          "data-is-out-of-stock": n.status === "out-of-stock" ? "true" : "false",
          className: "w-1/2 h-10 text-label-sm uppercase font-medium bg-transparent rounded-md border data-[is-out-of-stock=true]:text-less-emphasis-3 data-[is-selected=true]:text-white data-[is-selected=true]:bg-black relative data-[is-out-of-stock=true]:before:absolute data-[is-out-of-stock=true]:before:w-[1px] data-[is-out-of-stock=true]:before:h-[140%] data-[is-out-of-stock=true]:before:bg-less-emphasis-3 data-[is-out-of-stock=true]:before:top-[-20%] before:left-1/2 before:-translate-x-1/2 before:rotate-45 [&>svg]:w-5 [&>svg]:h-5",
          children: s("PDP_Size_Picker_One_Size")
        }
      );
    default:
      return null;
  }
}, mn = () => {
  const a = he(), i = me.styles(), n = k();
  return /* @__PURE__ */ d("div", { className: i.totalsWrapper, children: [
    /* @__PURE__ */ d("div", { className: i.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: i.totalsLabel, children: n("PDP_Bundle_Discount_Label") }),
      /* @__PURE__ */ d("span", { className: i.totalsValue, children: [
        "-",
        a.discountFromPriceOfItemsOutsideBundle.formatted
      ] })
    ] }),
    /* @__PURE__ */ d("div", { className: i.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: i.totalsLabel, children: n("PDP_Bundle_Price_Label") }),
      /* @__PURE__ */ e("span", { className: i.totalsValue, children: a.priceInfo.price.formatted })
    ] })
  ] });
}, hn = () => {
  const a = pa(), i = ma(), { execute: n } = wa("addBundleToCart"), [o, s] = pe.useState("default"), l = k(), r = async () => {
    if (i.status === "available")
      try {
        s("loading"), await n({
          itemId: a,
          sections: i.sections.map((u) => ({
            sectionId: u.sectionId,
            itemId: u.availableItemId
          }))
        }), await new Promise((u) => setTimeout(u, 1e3)), s("complete"), await new Promise((u) => setTimeout(u, 1e3));
      } catch {
        s("default"), await new Promise((m) => setTimeout(m, 1e3));
      } finally {
        s("default"), Y.emit("open", { overlayId: "mini-cart" });
      }
  }, c = i.status === "available";
  return /* @__PURE__ */ e(
    $,
    {
      as: "button",
      variants: {
        width: "full"
      },
      progress: o,
      "aria-disabled": c ? "false" : "true",
      label: l(rt[i.status]),
      onClick: r
    }
  );
}, te = t.object({
  items: t.array(
    t.object({
      label: t.string().optional(),
      icon: t.custom().optional()
    })
  ).optional(),
  attributeKey: t.string().optional(),
  variants: t.custom().optional()
}), bn = b(
  "ProductUspBlock",
  g(
    {
      schema: te,
      defaultProps: {
        attributeKey: "usps"
      }
    },
    ({ items: a, variants: i, attributeKey: n }) => {
      var l, r;
      const o = Zt.styles(i), s = (l = z(
        n ?? "usps",
        t.array(
          t.object({
            label: t.string(),
            icon: t.string().optional()
          })
        )
      )) == null ? void 0 : l.value;
      return !a && !s ? null : /* @__PURE__ */ e("div", { className: o.base, children: (r = a ?? s) == null ? void 0 : r.map((c, u) => /* @__PURE__ */ d("div", { className: o.item, children: [
        c.icon,
        /* @__PURE__ */ e("span", { className: o.label, children: c.label })
      ] }, u)) });
    }
  )
), gt = t.object({
  template: t.literal("scale"),
  variants: t.custom().optional(),
  /**
   * On a scale of. @default 10
   * @type {number}
   *  */
  onAScaleOf: t.number().optional()
}), gn = b(
  "ProductSizeRecommendationScale",
  g(
    {
      schema: gt,
      defaultProps: {
        template: "scale",
        onAScaleOf: 10
      }
    },
    ({ onAScaleOf: a }) => {
      C();
      const i = Yt.styles(), n = k(), o = z(
        "sizeRecommendation",
        t.string()
      ), s = z(
        "sizeRecommendationScale",
        t.string()
      );
      if (!(!(s != null && s.value) || !(o != null && o.value)))
        return /* @__PURE__ */ d("div", { className: i.base, children: [
          (s == null ? void 0 : s.value) && s.value && /* @__PURE__ */ d(R, { children: [
            /* @__PURE__ */ e("h3", { className: i.label, children: n("PDP_Size_Recommendation_Scale_Label") }),
            /* @__PURE__ */ e("div", { className: i.bar, children: /* @__PURE__ */ e(
              E.div,
              {
                className: i.dot,
                initial: {
                  left: `${parseInt(s.value) / (a ?? 10) * 100}%`,
                  scale: 0
                },
                whileInView: {
                  scale: 1
                },
                transition: {
                  delay: 0.25
                },
                exit: { scale: 0 }
              }
            ) }),
            /* @__PURE__ */ d("div", { className: i.scaleLabels, children: [
              /* @__PURE__ */ e("span", { className: i.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Small") }),
              /* @__PURE__ */ e("span", { className: i.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Perfect") }),
              /* @__PURE__ */ e("span", { className: i.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Big") })
            ] })
          ] }),
          (o == null ? void 0 : o.value) && /* @__PURE__ */ e("span", { className: i.sizeText, children: o.value })
        ] });
    }
  )
), fn = t.discriminatedUnion("template", [
  gt
]), Pn = b(
  "SizeRecommendation",
  g(fn, (a) => {
    if (a.template === "scale")
      return /* @__PURE__ */ e(gn, { ...a });
  })
), vn = t.object({
  variants: t.custom().optional(),
  template: t.enum(["button", "text"]).optional(),
  buttonVariants: Ia.shape.variants.optional()
}), Sn = b(
  "ProductBundleUpsell",
  g(
    {
      schema: vn,
      defaultProps: {
        template: "button",
        buttonVariants: {
          width: "full",
          color: "black",
          style: "outline"
        }
      }
    },
    ({ variants: a, buttonVariants: i, template: n }) => {
      const o = be("bundle")[0], s = k(), l = Jt.styles(a);
      return o ? /* @__PURE__ */ e(
        re,
        {
          productBase: o.product.base,
          className: l.base,
          children: n === "button" ? /* @__PURE__ */ e(
            Ee,
            {
              label: s("PDP_Bundle_Upsell_Title", {
                // Add support for discount when it exists.
                name: o.product.base.content.name
              }),
              variants: i
            }
          ) : /* @__PURE__ */ e("span", { children: s("PDP_Bundle_Upsell_Title", {
            name: o.product.base.content.name
          }) })
        }
      ) : null;
    }
  )
), ft = t.object({
  heading: t.string().optional(),
  subtitle: t.string().optional(),
  image: Oe.optional().nullable(),
  condition: t.string().optional(),
  variants: t.custom().optional()
}), yn = b(
  "ProductGiftWithPurchase",
  g(
    {
      schema: ft,
      defaultProps: {
        image: {
          displaySize: "5vw"
        }
      }
    },
    ({ heading: a, subtitle: i, image: n, variants: o, condition: s }) => {
      var r;
      const l = Xt.styles(o);
      return !a && !i && !n ? null : /* @__PURE__ */ d("div", { className: l.base, children: [
        /* @__PURE__ */ d("div", { className: l.contentWrapper, children: [
          n && ((r = n.image) == null ? void 0 : r.src) && /* @__PURE__ */ e(V, { ...n, className: l.image }),
          /* @__PURE__ */ d("div", { className: l.textWrapper, children: [
            a && /* @__PURE__ */ e("h3", { className: l.heading, children: a }),
            i && /* @__PURE__ */ e(Oa, { content: i, className: l.subtitle })
          ] })
        ] }),
        s && /* @__PURE__ */ e("span", { className: l.condition, children: s })
      ] });
    }
  )
), Pt = t.object({
  template: t.literal("cairo"),
  variants: t.custom().optional(),
  content: t.custom()
}), wn = b(
  "SizeGuideContent",
  g(Pt, ({ variants: a, content: i }) => {
    const n = ea.styles(a);
    return /* @__PURE__ */ e(Ra.Provider, { value: !0, children: /* @__PURE__ */ e("div", { className: n.contentWrapper, children: i }) });
  })
), vt = t.object({
  template: t.literal("drawer"),
  contentSettings: Pt.optional(),
  drawerSettings: t.custom().optional(),
  enabled: t.boolean().optional(),
  applyButtonSettings: ke.optional(),
  closeButtonSettings: ke.optional()
}), kn = "cairo", _n = 1024, Nn = b(
  "SizeGuideDrawer",
  g(vt, (a) => {
    ta.styles(), k();
    const i = a.contentSettings || {
      template: kn
    };
    if (!a.enabled)
      return null;
    const [n, o] = x(!1);
    return L(() => {
      const s = () => {
        o(window.innerWidth > _n);
      };
      return window.addEventListener("resize", s), s(), () => {
        window.removeEventListener("resize", s);
      };
    }, []), /* @__PURE__ */ e(
      A,
      {
        customOverlayId: "size-guide",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        hasHandle: !n,
        variants: {
          dragHandle: n ? "false" : "true",
          rounded: n ? "none" : "strong",
          background: "white",
          direction: n ? "right" : "bottom"
        },
        direction: n ? "right" : "bottom",
        ...a.drawerSettings,
        children: /* @__PURE__ */ e(A.Content, { children: /* @__PURE__ */ e(wn, { ...i }) })
      }
    );
  })
), ve = t.discriminatedUnion("template", [
  vt
]), Tn = b(
  "SizeGuide",
  g(ve, (a) => {
    switch (a.template) {
      case "drawer":
        return /* @__PURE__ */ e(Nn, { ...a });
      default:
        return null;
    }
  })
), Se = t.object({
  link: Aa.optional(),
  label: t.string().optional(),
  icon: t.custom().optional(),
  variants: t.custom().optional()
}), Bn = b(
  "SizeGuideTrigger",
  g(Se, ({ variants: a, label: i, link: n, icon: o }) => {
    const s = aa.styles(a);
    return /* @__PURE__ */ e(
      Da,
      {
        onClick: () => Y.emit("open", { overlayId: "size-guide" }),
        className: s.trigger,
        label: i,
        icon: o,
        ...n
      }
    );
  })
), Cn = t.object({
  variants: t.custom().optional()
}), An = ({ variants: a }) => {
  const i = k(), n = ia.styles(a), o = he(), s = o.discountFromPriceOfItemsOutsideBundle.formatted, l = o.discountFromPriceOfItemsOutsideBundle.number;
  return !s || l <= 0 ? null : /* @__PURE__ */ d("div", { className: n.base, children: [
    /* @__PURE__ */ e("h3", { className: n.heading, children: i("PDP_Bundle_Promo_Banner_Heading", {
      bundleSavings: s
    }) }),
    /* @__PURE__ */ e("p", { className: n.text, children: i("PDP_Bundle_Promo_Banner_Text") })
  ] });
}, Dn = b(
  "ProductBundlePromoBanner",
  g(
    {
      schema: Cn,
      defaultProps: {}
    },
    (a) => O() !== "bundle" ? null : /* @__PURE__ */ e(An, { ...a })
  )
), p = {
  SizeGuide: Tn,
  Details: ui,
  Root: qa,
  ImageGallery: wi,
  AddToCart: ji,
  Specifications: _i,
  Attributes: Ii,
  SizePicker: Ui,
  Siblings: Xi,
  RelatedProducts: an,
  StickyAddToCart: rn,
  Bundle: ln,
  BundleUpsell: Sn,
  UspBlock: bn,
  SizeGuideTrigger: Bn,
  SizeRecommendation: Pn,
  GiftWithPurchase: yn,
  BundlePromoBanner: Dn,
  PriceHistoryDrawer: ii
  // Add other components as needed
}, St = t.object({
  template: t.literal("basic"),
  variants: t.custom().optional(),
  productTypeSettings: ee.optional(),
  productDesignerSettings: ee.optional(),
  relatedProductsSettings: F.optional(),
  sizePickerSettings: ce.optional(),
  uspBlockSettings: te.optional(),
  siblingsPickerSettings: de.optional(),
  sizeGuideSettings: ve.optional(),
  sizeGuideTriggerSettings: Se.optional(),
  belowTheFoldComponents: t.custom().optional()
}), In = b(
  "ProductTemplateAsBasic",
  g(
    {
      schema: St,
      defaultProps: {
        template: "basic",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: i,
      uspBlockSettings: n,
      siblingsPickerSettings: o,
      sizeGuideSettings: s,
      sizeGuideTriggerSettings: l,
      belowTheFoldComponents: r
    }) => {
      var f;
      const c = C(), u = na.styles(), m = k();
      return /* @__PURE__ */ e(J, { mode: "wait", children: /* @__PURE__ */ d(
        E.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: c.productId,
          className: u.base,
          children: [
            /* @__PURE__ */ e(
              U,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden ml-3 mb-3"
              }
            ),
            /* @__PURE__ */ e(p.ImageGallery, { template: "keen", indicator: "number" }),
            /* @__PURE__ */ e(p.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ d("section", { className: u.detailsWrapper, children: [
              /* @__PURE__ */ e(
                U,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block mb-4"
                }
              ),
              /* @__PURE__ */ e(p.Details.Brand, {}),
              /* @__PURE__ */ e(p.Details.Name, {}),
              /* @__PURE__ */ e(p.Details.Price, {}),
              /* @__PURE__ */ e(p.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                p.Siblings,
                {
                  template: "image-card",
                  ...o
                }
              ),
              /* @__PURE__ */ e(p.SizeGuide, { template: "drawer", ...s }),
              /* @__PURE__ */ e(
                p.SizePicker,
                {
                  template: "button-grid",
                  ...i,
                  headerContent: /* @__PURE__ */ e(
                    p.SizeGuideTrigger,
                    {
                      ...l,
                      label: m("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(p.AddToCart, { template: "button" }),
              /* @__PURE__ */ e(p.UspBlock, { ...n }),
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  label: m("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              )
            ] }),
            /* @__PURE__ */ d("div", { className: u.belowTheFoldDetails, children: [
              /* @__PURE__ */ e(
                p.Details.Description,
                {
                  label: m("PDP_Product_Description_Label")
                }
              ),
              /* @__PURE__ */ e(
                p.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0,
                        defaultValue: "details"
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        trigger: m("PDP_Product_Details"),
                        value: "details",
                        content: c.content.description
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Material"),
                        attributeKey: "material"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        trigger: m("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e("div", { className: u.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(f = a == null ? void 0 : a.swiperSettings) == null ? void 0 : f.settings,
                    headerSettings: {
                      heading: {
                        heading: m("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            r
          ]
        }
      ) });
    }
  )
), yt = t.object({
  template: t.literal("helsinki"),
  breadcrumbsSettings: ja.optional(),
  imageGallerySettings: tt.optional(),
  addToCartSettings: ct.optional(),
  descriptionSettings: Ae.optional(),
  specificationSettings: it.optional(),
  progressBarSettings: Ie.optional(),
  tagsSettings: t.array(ze).optional(),
  relatedProductsSettings: F.optional(),
  discontinuedBadgeWrapper: Ke.optional(),
  shippingBarometer: Ka.optional(),
  id: t.string().optional()
}), zn = b(
  "ProductPageTemplateHelsinki",
  g(
    {
      schema: yt,
      defaultProps: {
        template: "helsinki",
        breadcrumbsSettings: {
          variants: {
            isOn: "pdp"
          }
        },
        discontinuedBadgeWrapper: {
          rotate: "randomize"
          // variants: {
          //   color: "red",
          // },
        },
        imageGallerySettings: {
          template: "keen",
          indicator: "dots"
        },
        addToCartSettings: {
          template: "quantity-picker"
        },
        descriptionSettings: {
          readMoreSettings: {
            enabled: !0,
            limit: 160
          }
        },
        specificationSettings: {
          template: "table"
        },
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      breadcrumbsSettings: a,
      imageGallerySettings: i,
      addToCartSettings: n,
      descriptionSettings: o,
      specificationSettings: s,
      progressBarSettings: l,
      tagsSettings: r,
      relatedProductsSettings: c,
      discontinuedBadgeWrapper: u,
      shippingBarometer: m,
      id: f
    }) => {
      var y;
      const { status: h } = ge(), P = k(), v = oa.styles();
      return /* @__PURE__ */ d(
        "section",
        {
          id: f,
          className: "grid-cols-12 lg:grid-rows-[min-content_max-content] grid lg:gap-4 w-full lg:gap-y-12 bg-white lg:px-8 rounded-lg lg:max-h-[90vh] overflow-y-scroll",
          children: [
            /* @__PURE__ */ d(p.ImageGallery, { ...i, template: "keen", children: [
              /* @__PURE__ */ e(
                U,
                {
                  ...a,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  }
                }
              ),
              h === "discontinued" && /* @__PURE__ */ e("div", { className: v.discountinuedBadgeWrapper, children: /* @__PURE__ */ e(
                Ce,
                {
                  label: P("PDP_Discontinued_Badge"),
                  ...u
                }
              ) })
            ] }),
            /* @__PURE__ */ d("div", { className: v.addToCartWrapper, children: [
              /* @__PURE__ */ e(p.Details.Name, {}),
              h === "out-of-stock" && /* @__PURE__ */ d("div", { className: v.outOfStock, children: [
                /* @__PURE__ */ e("span", { className: v.outOfStockIndicator }),
                /* @__PURE__ */ e("span", { children: P("PDP_Out_Of_Stock") })
              ] }),
              h === "discontinued" && /* @__PURE__ */ d("div", { className: v.discontinued, children: [
                /* @__PURE__ */ e("span", { className: v.discontinuedIndicator }),
                /* @__PURE__ */ e("span", { children: P("PDP_Discontinued_Message") })
              ] }),
              h !== "discontinued" && /* @__PURE__ */ e(
                p.AddToCart,
                {
                  ...n ?? { template: "quantity-picker" }
                }
              ),
              /* @__PURE__ */ e(
                Ma,
                {
                  ...m,
                  className: v.shippingBarometer
                }
              )
            ] }),
            /* @__PURE__ */ d("div", { className: v.detailsWrapper, children: [
              /* @__PURE__ */ e(p.Details.ShortDescription, {}),
              /* @__PURE__ */ e(p.Details.Description, { ...o }),
              /* @__PURE__ */ e(
                p.Specifications,
                {
                  ...s ?? { template: "table" }
                }
              )
            ] }),
            /* @__PURE__ */ d("div", { className: v.attributesWrapper, children: [
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  template: "progress-bar",
                  ...l
                }
              ),
              r && /* @__PURE__ */ e("div", { className: v.tags, children: r.map((S, w) => /* @__PURE__ */ e(p.Attributes, { ...S }, w)) })
            ] }),
            /* @__PURE__ */ e("div", { className: v.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(y = c == null ? void 0 : c.swiperSettings) == null ? void 0 : y.settings,
                    headerSettings: {
                      heading: {
                        heading: P("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      );
    }
  )
), wt = t.object({
  template: t.literal("malibu"),
  variants: t.custom().optional(),
  productTypeSettings: ee.optional(),
  relatedProductsSettings: F.optional(),
  siblingSettings: Le.optional(),
  sizePickerSettings: ce.optional(),
  uspBlockSettings: te.optional(),
  giftWithPurchaseSettings: ft.optional(),
  extendAccordion: t.array(Ye).optional(),
  sizeGuideSettings: ve.optional(),
  sizeGuideTriggerSettings: Se.optional(),
  priceSettings: Ze.optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  sizeFinderSlot: t.custom().optional(),
  openFirstAccordionItem: t.boolean().optional(),
  tagsComponentSlot: t.custom().optional(),
  accordionRootSettings: t.custom().optional()
}), Ln = b(
  "ProductTemplateAsMalibu",
  g(
    {
      schema: wt,
      defaultProps: {
        template: "malibu",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              itemsInView: {
                initial: "2.1",
                lg: "4.2",
                xl: "5"
              },
              variants: {
                layout: "stacked",
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: i,
      siblingSettings: n,
      sizePickerSettings: o,
      uspBlockSettings: s,
      extendAccordion: l,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: c,
      giftWithPurchaseSettings: u,
      priceSettings: m,
      belowTheFoldComponents: f,
      reviewComponentSlot: h,
      accordionRootSettings: P,
      sizeFinderSlot: v,
      tagsComponentSlot: y,
      openFirstAccordionItem: S
    }) => {
      var Q;
      const w = C(), N = sa.styles(), D = k(), I = z("fit_text", t.string()), [T, K] = x(
        void 0
      );
      return L(() => {
        const W = () => K("reviews");
        return window.addEventListener("pdp:open-reviews", W), () => window.removeEventListener("pdp:open-reviews", W);
      }, []), /* @__PURE__ */ d("section", { className: N.base, children: [
        /* @__PURE__ */ e($e, { template: "drawer" }),
        /* @__PURE__ */ e(p.ImageGallery, { template: "keen", indicator: "dots" }),
        /* @__PURE__ */ e(p.StickyAddToCart, { template: "button" }),
        /* @__PURE__ */ e(p.ImageGallery, { template: "grid" }),
        /* @__PURE__ */ d("section", { className: N.detailsWrapper, children: [
          /* @__PURE__ */ e(
            U,
            {
              enableWrapper: !1,
              variants: { isOn: "pdp" },
              layout: {
                spacing: { applySpacing: "false" },
                position: { applyPosition: "false" }
              }
            }
          ),
          /* @__PURE__ */ e(p.Details.Name, {}),
          /* @__PURE__ */ e(
            p.Details.Price,
            {
              ...m,
              priceHistoryDrawerSettings: {
                isEnabled: !0,
                trigger: /* @__PURE__ */ e(Ea, { className: "w-3 h-3 lg:w-4 lg:h-4 fill-[#71717a]" })
              }
            }
          ),
          /* @__PURE__ */ e(p.Details.ProductType, { ...i }),
          h,
          y,
          /* @__PURE__ */ e(p.Siblings, { template: "image-card", ...n }),
          /* @__PURE__ */ e(
            p.SizePicker,
            {
              template: "button-grid",
              ...o
            }
          ),
          /* @__PURE__ */ e(p.BundlePromoBanner, {}),
          /* @__PURE__ */ e(p.Bundle, {}),
          /* @__PURE__ */ e(
            p.AddToCart,
            {
              template: "button",
              isNotifyMeEnabled: (Q = o == null ? void 0 : o.notifyMe) == null ? void 0 : Q.enabled
            }
          ),
          v && v,
          /* @__PURE__ */ e(p.BundleUpsell, {}),
          (I == null ? void 0 : I.value) && /* @__PURE__ */ e("span", { className: N.fitText, children: I.value }),
          /* @__PURE__ */ e(p.SizeRecommendation, { template: "scale" }),
          (r == null ? void 0 : r.enabled) && /* @__PURE__ */ e(
            p.SizeGuideTrigger,
            {
              ...c,
              label: D("Size_Guide_Trigger_Label")
            }
          ),
          /* @__PURE__ */ e(p.SizeGuide, { template: "drawer", ...r }),
          /* @__PURE__ */ e(p.UspBlock, { ...s }),
          /* @__PURE__ */ e(p.GiftWithPurchase, { ...u }),
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "icon-blocks",
              attributeKey: "productFeaturesVariant"
            }
          ),
          /* @__PURE__ */ e(
            p.Details.Accordion,
            {
              items: [
                {
                  content: {
                    trigger: D("PDP_Product_Description"),
                    value: "description",
                    forceMount: !0,
                    content: w.content.description
                  }
                },
                {
                  content: {
                    trigger: D("PDP_Fabric_Care"),
                    attributeKey: "fabricCare_text",
                    forceMount: !0
                  }
                },
                {
                  content: {
                    trigger: D("PDP_Product_Details"),
                    forceMount: !0,
                    content: w.content.shortDescription
                  }
                },
                ...l ?? []
              ],
              settings: {
                radixAccordionSettings: {
                  root: P ?? {
                    type: "single",
                    value: T,
                    defaultValue: S ? "description" : void 0,
                    onValueChange: (W) => K(W)
                  }
                }
              }
            }
          )
        ] }),
        f
      ] });
    }
  )
), kt = t.object({
  template: t.literal("vienna"),
  variants: t.custom().optional(),
  relatedProductsSettings: F.optional(),
  sizePickerSettings: se.optional(),
  sizePicker2Settings: se.optional(),
  uspBlockSettings: te.optional(),
  imageGallerySettings: Pe.optional(),
  siblingsPickerSettings: de.optional(),
  reviewCarouselComponent: t.custom().optional(),
  reviewStarsComponent: t.custom().optional(),
  detailsComponentSlot: t.custom().optional(),
  sizeGuideComponentSlot: t.custom().optional(),
  beforeSiblingsSlot: t.custom().optional(),
  afterSiblingsSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  afterAddToCartSlot: t.custom().optional(),
  afterAttributesSlot: t.custom().optional()
}), xn = () => /* @__PURE__ */ e(p.AddToCart, { template: "button" }), Gn = ({
  sizePickerSettings: a,
  sizePicker2Settings: i
}) => {
  const n = k(), o = ha();
  return /* @__PURE__ */ e(R, { children: o ? /* @__PURE__ */ d(R, { children: [
    /* @__PURE__ */ e(p.SizePicker, { ...a, template: "modal" }),
    /* @__PURE__ */ e(
      p.SizePicker,
      {
        ...i,
        template: "modal",
        triggerLabel: n("PDP_Add_To_Cart"),
        customOverlayId: "size-picker-modal-2"
      }
    )
  ] }) : /* @__PURE__ */ e(
    oe,
    {
      label: n("PDP_Out_Of_Stock"),
      disabled: !0,
      "aria-disabled": "true",
      variants: {
        width: "full"
      }
    }
  ) });
}, Wn = b(
  "ProductTemplateAsVienna",
  g(
    {
      schema: kt,
      defaultProps: {
        template: "vienna",
        sizePickerSettings: {
          template: "modal",
          buttonVariants: {
            color: "black",
            style: "outline",
            width: "full"
          }
        },
        sizePicker2Settings: {
          template: "modal",
          buttonVariants: {
            style: "solid",
            width: "full"
          }
        },
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: i,
      sizePicker2Settings: n,
      uspBlockSettings: o,
      imageGallerySettings: s,
      siblingsPickerSettings: l,
      reviewCarouselComponent: r,
      detailsComponentSlot: c,
      reviewStarsComponent: u,
      sizeGuideComponentSlot: m,
      beforeSiblingsSlot: f,
      afterSiblingsSlot: h,
      belowTheFoldComponents: P,
      afterAddToCartSlot: v,
      afterAttributesSlot: y
    }) => {
      var W, ae, ie, _, B;
      const S = C(), w = ra.styles(), N = k(), D = O(), I = (W = z(
        "product_highlight_text",
        t.string()
      )) == null ? void 0 : W.value, T = (ae = z(
        "pr_video_url",
        t.string()
      )) == null ? void 0 : ae.value, K = (ie = z("pr_badge", t.string().array())) == null ? void 0 : ie.value, Q = D === "simple";
      return /* @__PURE__ */ d("section", { className: w.base, children: [
        /* @__PURE__ */ e("div", { className: w.breadcrumbsWrapper, children: /* @__PURE__ */ e(
          U,
          {
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            }
          }
        ) }),
        /* @__PURE__ */ e(
          p.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            buttonInSlider: {
              enabled: !!(T && (T == null ? void 0 : T.length) > 0),
              onClick: () => {
                const G = document == null ? void 0 : document.getElementById("youtube-video");
                G && G.scrollIntoView({ behavior: "smooth" });
              },
              label: N("Product_Video_Button_Text")
            },
            ...s,
            children: /* @__PURE__ */ e("div", { className: w.badgesWrapper, children: K == null ? void 0 : K.map((G, q) => /* @__PURE__ */ e(Ce, { label: G }, q)) })
          }
        ),
        /* @__PURE__ */ d("section", { className: w.detailsWrapper, children: [
          /* @__PURE__ */ d("div", { className: "flex flex-row justify-between items-center lg:mt-0 mb-2", children: [
            /* @__PURE__ */ d("div", { className: "flex items-center empty:hidden flex-wrap", children: [
              /* @__PURE__ */ e(p.Details.ProductType, { attributeKey: "wiring" }),
              ((_ = z("wiring", t.string())) == null ? void 0 : _.value) && ((B = z("padding", t.string())) == null ? void 0 : B.value) && /* @__PURE__ */ e("span", { className: "m-1 mb-2", children: "•" }),
              /* @__PURE__ */ e(p.Details.ProductType, { attributeKey: "padding" })
            ] }),
            u
          ] }),
          /* @__PURE__ */ e(p.Details.Name, {}),
          /* @__PURE__ */ e(p.Details.Price, {}),
          f,
          /* @__PURE__ */ e(
            p.Siblings,
            {
              template: "color-swatch",
              ...l
            }
          ),
          h,
          /* @__PURE__ */ d("div", { className: "flex flex-col gap-2", children: [
            m,
            /* @__PURE__ */ e(
              "div",
              {
                className: "w-full flex flex-row gap-4",
                id: "add-to-cart-component",
                children: Q ? /* @__PURE__ */ e(xn, {}) : /* @__PURE__ */ e(
                  Gn,
                  {
                    sizePicker2Settings: n,
                    sizePickerSettings: i
                  }
                )
              }
            ),
            v
          ] }),
          /* @__PURE__ */ e(p.UspBlock, { ...o }),
          /* @__PURE__ */ e(
            p.StickyAddToCart,
            {
              template: "button",
              mode: "isNotVisible",
              selectSizeAction: "open-size-picker",
              withSizePicker: !0
            }
          )
        ] }),
        /* @__PURE__ */ e(p.Details.Description, {}),
        I && /* @__PURE__ */ e("ul", { className: w.highlightTextWrapper, children: I == null ? void 0 : I.split(";").map((G, q) => /* @__PURE__ */ e("li", { className: w.highlightTextRow, children: G }, q)) }),
        /* @__PURE__ */ d("section", { className: w.attributesWrapper, children: [
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "row",
              attributeKey: "material_pdp_text"
            }
          ),
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "row",
              attributeKey: "washing_advice_text"
            }
          ),
          /* @__PURE__ */ e(
            p.Attributes,
            {
              template: "row",
              attributeKey: "product_key",
              data: {
                attributeLabel: N("Article_Number"),
                value: S.productKey
              }
            }
          )
        ] }),
        y,
        T && /* @__PURE__ */ e("div", { className: w.productVideo, id: "youtube-video", children: /* @__PURE__ */ e(
          "div",
          {
            className: "relative w-full",
            style: { paddingBottom: "56.25%" },
            children: /* @__PURE__ */ e(
              "iframe",
              {
                className: "absolute top-0 left-0 w-full h-full",
                src: T.includes("youtube.com/watch?v=") ? `https://www.youtube.com/embed/${T.split("v=")[1]}` : T,
                title: "Product video",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          p.RelatedProducts,
          {
            template: "image-cards",
            relationType: "standard",
            ...a
          }
        ),
        c,
        P
      ] });
    }
  )
), _t = t.object({
  template: t.literal("graz"),
  variants: t.custom().optional(),
  productTypeSettings: ee.optional(),
  productDesignerSettings: ee.extend({
    link: t.string().optional()
  }).optional(),
  relatedProductsSettings: F.optional(),
  sizePickerSettings: ce.optional(),
  uspBlockSettings: te.optional(),
  siblingsPickerSettings: de.optional(),
  sizeGuideSettings: ve.optional(),
  sizeGuideTriggerSettings: Se.optional(),
  productSku: t.string().optional(),
  ecomidNudgeSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional()
}), On = b(
  "ProductTemplateAsGraz",
  g(
    {
      schema: _t,
      defaultProps: {
        template: "graz",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: i,
      productDesignerSettings: n,
      sizePickerSettings: o,
      uspBlockSettings: s,
      siblingsPickerSettings: l,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: c,
      ecomidNudgeSlot: u,
      belowTheFoldComponents: m,
      productSku: f
    }) => {
      var S, w, N;
      const h = C(), P = la.styles(), v = k(), y = Ha();
      return /* @__PURE__ */ e(J, { mode: "wait", children: /* @__PURE__ */ d(
        E.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: h.productId,
          className: P.base,
          children: [
            /* @__PURE__ */ e($e, { template: "drawer" }),
            /* @__PURE__ */ e(
              U,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden"
              }
            ),
            /* @__PURE__ */ e(p.ImageGallery, { template: "keen", indicator: "dots" }),
            /* @__PURE__ */ e(p.StickyAddToCart, { template: "button" }),
            /* @__PURE__ */ e(p.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ d("section", { className: P.detailsWrapper, children: [
              /* @__PURE__ */ e(
                U,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block"
                }
              ),
              /* @__PURE__ */ d("div", { className: P.tagsWrapper, children: [
                /* @__PURE__ */ e(p.Details.ProductType, { ...i }),
                /* @__PURE__ */ e(y, { href: (n == null ? void 0 : n.link) ?? "", children: /* @__PURE__ */ e(p.Details.ProductType, { ...n }) })
              ] }),
              /* @__PURE__ */ e(p.Details.Name, {}),
              /* @__PURE__ */ e(p.Details.Price, {}),
              /* @__PURE__ */ e(p.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                p.Siblings,
                {
                  template: "color-swatch",
                  ...l
                }
              ),
              /* @__PURE__ */ e(p.SizeGuide, { template: "drawer", ...r }),
              /* @__PURE__ */ e(
                p.SizePicker,
                {
                  template: "button-grid",
                  ...o,
                  headerContent: /* @__PURE__ */ e(
                    p.SizeGuideTrigger,
                    {
                      ...c,
                      label: v("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(
                p.AddToCart,
                {
                  template: "button",
                  isNotifyMeEnabled: (S = o == null ? void 0 : o.notifyMe) == null ? void 0 : S.enabled
                }
              ),
              /* @__PURE__ */ e(p.UspBlock, { ...s }),
              /* @__PURE__ */ e("div", { className: P.retracedIcons, children: /* @__PURE__ */ e("retraced-icons", {}) }),
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  label: v("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              ),
              /* @__PURE__ */ e(
                p.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Product_Details"),
                        content: h.content.description
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Product_Material"),
                        attributeKey: "pr_fabric"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: v("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              ),
              /* @__PURE__ */ e(
                p.Attributes,
                {
                  label: v("PDP_Product_Certifications"),
                  template: "icon-blocks",
                  attributeKey: "certifications"
                }
              ),
              u,
              /* @__PURE__ */ e("span", { className: P.productId, children: v("PDP_Product_Id", {
                productId: h.productId,
                sku: f || ""
              }) })
            ] }),
            /* @__PURE__ */ e("div", { className: P.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(w = a == null ? void 0 : a.swiperSettings) == null ? void 0 : w.settings,
                    headerSettings: {
                      heading: {
                        heading: v("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            m,
            /* @__PURE__ */ e("div", { className: P.relatedProductsWrapper, children: /* @__PURE__ */ e(
              p.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(N = a == null ? void 0 : a.swiperSettings) == null ? void 0 : N.settings,
                    headerSettings: {
                      heading: {
                        heading: v("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      ) });
    }
  )
), Nt = t.object({
  template: t.literal("salzburg"),
  variants: t.custom().optional(),
  relatedProductsSettings: F.optional(),
  sizePickerSettings: se.optional(),
  uspBlockSettings: te.optional(),
  siblingsPickerSettings: de.optional(),
  imageGallerySettings: Pe.optional(),
  descriptionSettings: Ae.optional(),
  nameSettings: Qe.optional(),
  customSiblings: t.custom().optional()
}), Rn = b(
  "ProductTemplateAsSalzburg",
  g(
    {
      schema: Nt,
      defaultProps: {
        template: "salzburg",
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      sizePickerSettings: a,
      imageGallerySettings: i,
      nameSettings: n,
      descriptionSettings: o,
      siblingsPickerSettings: s,
      variants: l,
      customSiblings: r
    }) => {
      const c = ne.main.styles(l), u = k();
      return /* @__PURE__ */ d("section", { className: c.base, children: [
        /* @__PURE__ */ d("section", { className: c.detailsWrapper, children: [
          /* @__PURE__ */ e(
            p.Details.Name,
            {
              ...n,
              blueprint: ne.details
            }
          ),
          /* @__PURE__ */ e(
            p.Details.Description,
            {
              ...o,
              blueprint: ne.details
            }
          ),
          r || /* @__PURE__ */ e(
            p.Siblings,
            {
              template: "color-swatch",
              ...s
            }
          ),
          /* @__PURE__ */ d("div", { className: "w-full flex flex-col lg:flex-row gap-3 lg:gap-4 justify-between", children: [
            /* @__PURE__ */ e(
              p.Details.Price,
              {
                blueprint: ne.details
              }
            ),
            /* @__PURE__ */ e(
              p.SizePicker,
              {
                template: "modal",
                ...a,
                triggerLabel: "PDP_Add_To_Cart"
              }
            )
          ] }),
          /* @__PURE__ */ e("span", { className: c.returnPolicyWrapper, children: u("Product_Return_Policy") })
        ] }),
        /* @__PURE__ */ e(
          p.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            blueprint: ne.gallery,
            ...i
          }
        )
      ] });
    }
  )
), Tt = t.object({
  template: t.literal("linz"),
  variants: t.custom().optional()
}), jn = b(
  "ProductTemplateAsLinz",
  g(Tt, () => /* @__PURE__ */ d(p.Root, { template: "grid", children: [
    /* @__PURE__ */ e(
      p.ImageGallery,
      {
        template: "keen",
        indicator: "number",
        slidesPerView: { mobile: 1, tablet: 1, desktop: 3 },
        gap: { mobile: 0, tablet: 0, desktop: 0 }
      }
    ),
    /* @__PURE__ */ d("div", { className: "col-span-12 lg:col-start-9 lg:col-end-13 top-0 left-0 row-start-1 row-end-2 flex flex-col p-4 bg-[#aeaeae7d] backdrop-blur-lg rounded-lg sticky right-6 place-self-end w-full order-2 h-fit lg:self-end lg:p-6", children: [
      /* @__PURE__ */ e(p.Details.Name, {}),
      /* @__PURE__ */ e(p.Details.Price, {}),
      /* @__PURE__ */ e(p.Siblings, { template: "image-card" }),
      /* @__PURE__ */ e(p.SizePicker, { template: "button-grid" }),
      /* @__PURE__ */ e(p.AddToCart, { template: "button" })
    ] })
  ] }))
), Kn = t.discriminatedUnion("template", [
  St,
  yt,
  wt,
  kt,
  _t,
  Nt,
  Tt
]), Bo = b(
  "ProductTemplate",
  g(Kn, (a) => a.template === "basic" ? /* @__PURE__ */ e(In, { ...a }) : a.template === "helsinki" ? /* @__PURE__ */ e(zn, { ...a }) : a.template === "malibu" ? /* @__PURE__ */ e(Ln, { ...a }) : a.template === "vienna" ? /* @__PURE__ */ e(Wn, { ...a }) : a.template === "graz" ? /* @__PURE__ */ e(On, { ...a }) : a.template === "salzburg" ? /* @__PURE__ */ e(Rn, { ...a }) : a.template === "linz" ? /* @__PURE__ */ e(jn, { ...a }) : null)
), Co = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ e(
      "path",
      {
        stroke: "#18181B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.5999 4-7.7 7.7-3.5-3.5"
      }
    )
  }
);
export {
  di as Accordion,
  ji as AddToCart,
  Ri as AddToCartButton,
  Gi as AddToCartQuanityPickerRow,
  Wi as AddToCartQuantityPicker,
  Ii as Attributes,
  Ci as AttributesAsIconBlocks,
  Ti as AttributesAsProgressBar,
  Ai as AttributesAsRow,
  Bi as AttributesAsTags,
  Di as AttributesPropsSchema,
  To as AttributesTagsItemSchema,
  In as Basic,
  ti as Brand,
  ei as BrandSchema,
  ln as Bundle,
  Dn as BundlePromoBanner,
  Je as BundleSavingsBadge,
  Sn as BundleUpsell,
  Co as Checkmark,
  Va as CrossSvg,
  Xa as Description,
  ui as Details,
  yn as GiftWithPurchase,
  On as Graz,
  zn as Helsinki,
  zi as IconMinus,
  Li as IconPlus,
  wi as ImageGallery,
  Si as ImageGalleryAsGrid,
  Pi as ImageGalleryAsKeen,
  jn as Linz,
  Ln as Malibu,
  Za as Name,
  ni as Price,
  ii as PriceHistoryDrawer,
  Ze as PriceSchema,
  p as Product,
  Bo as ProductTemplate,
  Kn as ProductTemplatePropsSchema,
  li as ProductType,
  an as RelatedProducts,
  mt as RelatedProductsImageCards,
  tn as RelatedProductsSwiper,
  qa as Root,
  Ua as RootAsDrawer,
  $a as RootAsDrawerDialog,
  Ue as RootAsDrawerSchema,
  Fa as RootAsGrid,
  Fe as RootAsGridSchema,
  Qa as RootPropsSchema,
  De as SHOP_THE_LOOK_ATTRIBUTE_KEY,
  rt as STATUS_TRANSLATIONS,
  Rn as Salzburg,
  Xe as ShopTheLook,
  bi as ShopTheLookItem,
  Ja as ShortDescription,
  Ya as ShortDescriptionSchema,
  Ji as SiblingColorSwatchList,
  Xi as Siblings,
  Fi as SiblingsImageCard,
  Tn as SizeGuide,
  wn as SizeGuideContent,
  Nn as SizeGuideDrawer,
  Bn as SizeGuideTrigger,
  Ui as SizePicker,
  Ki as SizePickerButtonGrid,
  Vi as SizePickerModal,
  Pn as SizeRecommendation,
  gn as SizeRecommendationScale,
  _i as Specifications,
  ki as SpecificationsAsTable,
  at as SpecificationsAsTableSchema,
  rn as StickyAddToCart,
  on as StickyAddToCartButton,
  dt as Swatch,
  bn as UspBlock,
  Wn as Vienna,
  ri as Wrapper,
  si as WrapperSchema,
  Ye as accordionItemSchema,
  ci as accordionSchema,
  lt as addToCartButtonSchema,
  st as addToCartQuantityPickerSchema,
  ct as addToCartSchema,
  nt as attributesAsIconBlocksSchema,
  Ie as attributesAsProgressBarSchema,
  ot as attributesAsRowSchema,
  ze as attributesAsTagsSchema,
  Ni as attributesProgressBarItemSchema,
  pi as bundleSavingsBadgeSchema,
  Ae as descriptionSchema,
  ft as giftWithPurchaseSchema,
  et as imageGalleryAsGridSchema,
  Pe as imageGalleryAsKeenSchema,
  tt as imageGalleryPropsSchema,
  Qe as nameSchema,
  qe as priceHistoryDrawerSchema,
  gt as productSizeRecommendationScaleSchema,
  St as productTemplateAsBasicSchema,
  _t as productTemplateAsGrazSchema,
  yt as productTemplateAsHelsinkiSchema,
  Tt as productTemplateAsLinzSchema,
  wt as productTemplateAsMalibuSchema,
  Nt as productTemplateAsSalzburgSchema,
  kt as productTemplateAsViennaSchema,
  ee as productTypeSchema,
  pt as relatedProductsImageCardsSchema,
  F as relatedProductsSchema,
  ht as relatedProductsSwiperSchema,
  hi as shopTheLookItemSchema,
  gi as shopTheLookSchema,
  ut as siblingColorSwatchListSchema,
  Le as siblingsImageCardSchema,
  de as siblingsSchema,
  Pt as sizeGuideContentSchema,
  vt as sizeGuideDrawerSchema,
  ve as sizeGuideSchema,
  Se as sizeGuideTriggerSchema,
  ce as sizePickerButtonGridSchema,
  se as sizePickerModalSchema,
  $i as sizePickerSchema,
  fn as sizeRecommendationSchema,
  it as specificationsPropsSchema,
  bt as stickyAddToCartButtonSchema,
  sn as stickyaddToCartSchema,
  Oi as useAddToCartLabel,
  nn as useElementVisibility,
  te as uspBlockSchema
};
//# sourceMappingURL=index.es.js.map
